import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          generic: {
            successTitle: 'Success',
            successDescription: 'Successfully updated',
            errorTitle: 'Something went wrong',
            errorDescription: 'Something went wrong, please try again.',
            missingKeyReplacement: '...',
            yes: 'Yes',
            no: 'No',
            remove: 'Delete',
            close: 'Close',
            back: 'Back',
            edit: 'Edit',
            cancel: 'Cancel',
            ok: 'OK',
            save: 'Save',
            update: 'Update',
            email: 'E-mail',
            phone: 'Phone number',
            search: 'Search',
            create: 'Create',
            missingFieldsTitle: 'Fields missing',
            missingFieldsDescription: 'One or more fields have missing or incorrect information',
            saving: 'Saving',
            uploadImageFiles: "Click to upload images or drag and drop PNG, JPG, JPEG or GIF",
            uploadDocumentFiles: "Click to upload files or drag and drop GIF, JPG, JPEG, PDF or PNG",
            warning: "Warning",
            areyousure: "Are you sure?",
            airPark: 'AirPark',
            share: 'Share',
            add: 'Add',
            invite: 'Invite',
            signin: 'Sign in',
            signup: 'Sign up',
            signout: 'Sign out',
            create: 'Create',
            status: 'Status',
            firstName: 'First name',
            lastName: 'Last name',
            from: 'From',
            to: 'To',
            id: 'Id',
            amount: 'Amount',
            status: 'Status',
            choose: 'Choose',
            change: 'Change',
            revoke: 'Revoke',
            videoInstructions: 'Video instructions',
            updated: 'Updated',
            updatedDescription: 'Updated successfully',
            download: 'Download',
            day: 'Day',
            month: 'Month',
            pending: 'Pending',
            copy: 'Copy',
            copied: 'Copied',
            copiedDescription: 'Copied to clipboard',
            price: 'Price',
            unit: 'Unit',
            termsAndConditionsUrl: 'https://static.airpark.app/policy/2023/terms_and_conditions_en-se.pdf',
            upload: 'Upload',
            all: 'All',
            selected: 'Selected'
          },
          error: {
            userAlreadyHaveAnIndividualOrganizationTitle: 'You already have an individual organization',
            userAlreadyHaveAnIndividualOrganizationDescription: 'You can not have multiple individual organizations',
            priceRuleSetRecurringTimeEqualTitle: 'Recurring Time can not be 24 hours',
            priceRuleSetRecurringTimeEqualDescription: 'Time From and Time To can not be the same. Please adjust the time range.',
          },
          validation: {
            invalidPhoneNumber: 'Invalid phone number',
            requiredField: 'Required field',
            invalidPrice: 'Invalid price',
          },
          legend: {
            totalAmount: 'Total revenue',
            bookingsAmount: 'Bookings',
            permitsAmount: 'Permits',
            controlFeesAmount: 'Control fees',
            revenue: 'Revenue',
          },
          dayShortNames: {
            monday: 'Mon',
            tuesday: 'Tue',
            wednesday: 'Wed',
            thursday: 'Thu',
            friday: 'Fri',
            saturday: 'Sat',
            sunday: 'Sun'
          },
          daySingularNames: {
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            sunday: 'Sunday'
          },
          dayPluralNames: {
            monday: 'Mondays',
            tuesday: 'Tuesdays',
            wednesday: 'Wednesdays',
            thursday: 'Thursdays',
            friday: 'Fridays',
            saturday: 'Saturdays',
            sunday: 'Sundays'
          },
          navigation: {
            'parking-areas': 'Parking areas',
            'permits': 'Permits',
            'queue': 'Queue',
            'community': 'Community',
            'control-fees': 'Control fees',
            'marketplace': 'Marketplace',
            'parking-spots': 'Parking spots',
            'settings': 'Settings',
            'users': 'Users',
            'connect-requests': 'Connect requests',
            'reports': 'Reports',
            'payouts': 'Payout',
            'revenue': 'Revenue',
            'revenue-sharing': 'Revenue sharing',
            'occupancy': 'Occupancy',
            'payout': 'Payouts',
            'signs': 'Signs',
            'statistics': 'Statistics',
            'custom-agreement': 'Custom agreement',
            'bookings': 'Bookings',
            'connections': 'Community connections',
            'charging': 'Charging',
            'airpass': 'AirPass',
            'contract-codes': 'Contract codes',
          },
          paging: {
            pageOfTotal: 'Page {{page}} of {{total}}'
          },
          priceUnit: {
            hour: 'hour',
            day: 'day',
            month: 'month',
            onetime: 'one-time',
            kWh: 'kWh',
          },
          defaultLayout: {
            loading: 'Loading...'
          },
          loginPage: {
            byLoggingInYouApprove: "By signing in you approve of the",
            conditions: "conditions",
            rememberMe: "Remember me",
            mobileNumber: "Mobile number",
            selectCountryCode: "Select country/code",
            search: "search",
            loginWithMobileNumber: 'Login with mobile number',
            loginWithEmail: 'Login with e-mail',
            emailIsNotValid: 'E-mail is not valid',
            noAccountSignup: 'No account? Register here',
            useTheApp: 'Did you know that it\'s super easy to rent out your parking space with the AirPark app? Download it here',
          },
          verifySmsCodePage: {
            verifyCode: "Enter code",
            enterTheCodeThatWasSentTo: "Enter the code that was sent to",
            didNotReceiveCode: "Did not receive a code? Try again",
            newCodeSentTitle: "New code sent",
            newCodeSentDescription: "A new code has been sent to phone number",
            codeCouldNotBeVerifiedTitle: "Code not valid",
            codeCouldNotBeVerifiedDescription: "Your code couldn't be verified. Please try again."
          },
          registerPage: {
            beforeWeGetStarted: "Before we get started",
            description: "In order to be part of the service and provide you with a fantastic experiene we need a little more information.",
            firstName: "Firstname",
            surName: "Surname",
            country: 'Country',
            accept: 'I accept AirPark\'s',
            termsAndConditions: 'terms and conditions',
          },
          chooseOrganizationPage: {
            chooseOrganization: "Choose organization",
            description: "Available organizations that you can administer parkings for.",
            createNewOrganization: "Create new organization",
            noOrganizationAvailableTitle: "No organization available",
            noOrganizationAvailableDescription: "No organization available. Create an organization to organize your parkings."
          },
          createOrganizationPage: {
            createOrganization: "Create organization",
            description: "Create an organization for your parkings. This could be your name, the name of your housing cooperative or company.",
            nameMissingTitle: 'Name missing',
            nameMissingDescription: 'You need to fill out the name of the organization.',
            typeOfOrganization: 'Company or individual?',
            typeOfOrganizationTooltip: 'Choose which organization type you are signing up as. Anything other than individual should choose company as organization type.',
            company: 'Company',
            individual: 'Individual',
            country: 'Country',
            name: 'Name',
            orgNbr: 'Organization number',
            socialSecurityNumber: 'Social Security number',
            address: 'Address',
            zipCode: 'Zip code',
            city: 'City',
            phone: 'Phone number',
            email: 'E-mail',
            youMustAcceptTermsAndConditionsTitle: 'You must accept terms and conditions',
            youMustAcceptTermsAndConditionsDescription: 'You must accept the terms and conditions to continue.',
            missingRequiredInfoTitle: 'Required info missing',
            missingRequiredInfoDescription: 'You need to fill out all of the required information.',
          },
          leftMenu: {
            start: "Start",
            areas: "Areas",
            reports: "Reports",
            users: "Users",
            settings: "Settings",
            payouts: 'Payouts',
            occupancy: 'Occupancy',
            revenue: 'Revenue',
            payoutSettings: 'Payout account',
            revenueSharing: 'Revenue sharing',
            statistics: 'Statistics',
          },
          leftMenuParkingArea: {
            parking: "Parking",
            permits: "Permits",
            queue: "Queue",
            controlfees: "Control fees",
            community: "Community",
            parkingSpots: "Parking spots",
            marketplace: "Marketplace",
            communityConnectRequests: 'Connect requests',
            controlFeesSettings: 'Control fees settings',
            signs: 'Sign material',
            charging: 'Charging',
            linkedCommunities: 'Linked communities',
            airPass: 'AirPass',
            customAgreement: 'Custom agreement',
            bookings: 'Bookings',
            parkingSpotsPrice: 'Pricelist',
            contractCodes: 'Contract codes',
            discountCodes: 'Discount codes',
            objectIds: 'ObjectIDs',
            assignment: 'Assignment (bulk issue)'
          },
          assignment: {
            title: 'Bulk permit assignment',
            subtitle: 'Bulk update permits using an Excel file.',
            description: 'Download the Excel template (pre-filled with parking spots that have an ObjectID), fill in phone numbers, registration plates and dates, then upload. Gray columns are locked — only edit the white columns.',
            howItWorksTitle: 'How the file is processed',
            step1Title: 'Format',
            step2Title: 'Upload file',
            step3Title: 'Preview',
            step4Title: 'Done',
            uploadStepTitle: 'Upload Excel file',
            uploadStepDescription: 'Pick the filled-in template or import directly from your property management system.',
            previewStepTitle: 'Preview assignments',
            clientErrors: 'Errors in the file',
            clientWarnings: 'Warnings',
            continue: 'Continue',
            back: 'Back',
            startOver: 'Start over',
            confirmReset: 'Discard the loaded file and start over?',
            rerunDryRun: 'Check again',
            uploadAnother: 'Upload another file',
            rowTableHelp: 'The table shows every row. Classification is on the right — fix incorrect rows in Excel and upload the file again.',
            tableHelp: 'Click any cell to edit it directly.',
            editedRowsLabel: 'Edited rows: {{count}}. Click "Check against system" to verify.',
            editedTooltip: 'Edited in the portal',
            clickToEdit: 'Click to edit',
            downloadEdited: 'Download updated template',
            colRow: 'Row',
            colSpotIdentifier: 'Spot',
            colKind: 'Classification',
            kindIgnored: 'Skipped',
            kindDormant: 'Dormant user',
            kindActivate: 'Permit',
            kindError: 'Error',
            howItWorks_create: 'Empty parking spot + new phone number → creates a new permit (and a dormant user if the phone is unknown).',
            howItWorks_create_label: 'New permit',
            howItWorks_update: 'Existing permit for the same person on the same spot + new end date → updates the end date.',
            howItWorks_update_label: 'End date updated',
            howItWorks_transition: 'Two rows on the same spot — one ends an existing permit, the next starts a new one (e.g. Kalle ends 2026-05-31 → Lisa starts 2026-06-01).',
            howItWorks_transition_label: 'Transition',
            howItWorks_dormant: 'Phone number alone (no dates) → only creates a dormant user, no permit.',
            howItWorks_dormant_label: 'Dormant user',
            howItWorks_noChange: 'Same data as already exists → nothing changes.',
            howItWorks_noChange_label: 'No change',
            howItWorks_ignored: 'Empty phone number → row is ignored.',
            howItWorks_ignored_label: 'Empty row ignored',
            howItWorks_phoneFormat: 'Phone numbers are normalized — both 0701234567 and +46701234567 work and match the same user.',
            howItWorks_phoneFormat_label: 'Phone format',
            duplicateRowError: 'Rows {{rows}} share the same ObjectID "{{objectId}}" + phone "{{phone}}" — only unique combinations are allowed in this upload. Fix the file and try again.',
            unknownExtIdError: 'Spot ID does not exist in this area ({{details}}). The Spot ID column must not be edited — download the template again and fill in the white columns.',
            downloadTemplate: 'Download template',
            uploadExcel: 'Upload Excel',
            dryRun: 'Check against system',
            execute: 'Issue permits',
            confirmExecute: 'This will create permits and dormant users. Continue?',
            rowsLoaded: 'Rows loaded',
            dryRunResult: 'Dry-run result',
            executeResult: 'Execution result',
            blockingErrors: 'Blocking errors',
            blockedByErrors: 'Upload blocked by errors',
            totalRows: 'Total rows',
            newPermits: 'New permits',
            updatedPermits: 'Updated permits',
            transitions: 'Transitions',
            dormantUsers: 'Dormant users',
            noChange: 'No change',
            ignored: 'Ignored',
            rowIndex: 'Row',
            phone: 'Phone',
            action: 'Action',
            message: 'Message',
            colAction: 'What happens',
            colPrice: 'Price',
            colSublet: 'Sublet',
            colThirdParty: 'Other party',
            colSpot: 'Spot',
            colObjectId: 'ObjectID',
            colPhone: 'Phone',
            colReg: 'Registration',
            colFromDate: 'From',
            colToDate: 'To',
            colExplanation: 'Explanation',
            permitsCreated: 'permits created',
            loadFailed: 'Failed to load parking spots',
            parseFailed: 'Failed to parse Excel file',
            dryRunFailed: 'Dry-run failed',
            executeFailed: 'Execution failed',
            importFromExternal: 'Import from property system',
            importedFromExternal: 'Imported {{count}} rows from external system'
          },
          assignmentImport: {
            title: 'Import from property system',
            description: 'Upload a file in your property-system format (Yardi, Re! etc). Then map each AirPark field to the matching column.',
            emptyFile: 'The file contains no rows.',
            parseFailed: 'Could not parse the file. Make sure it is a valid Excel file.',
            rawDataPreview: 'Raw data preview ({{count}} rows total)',
            columnMapping: 'Column mapping (AirPark field → Excel column)',
            convertedPreview: 'Preview after mapping (5 first rows)',
            notMapped: '— not mapped —',
            missingFields: 'Missing required fields: {{fields}}',
            useMapping: 'Use mapping'
          },
          objectIds: {
            title: 'ObjectID per parking spot',
            description: 'Download the Excel file, edit the Spot number or ObjectID columns, and upload again to mass-update. The Spot ID column is locked (internal key).',
            download: 'Download Excel',
            upload: 'Upload Excel',
            uploading: 'Uploading...',
            spotIdentifier: 'Spot number',
            objectId: 'ObjectID',
            loadFailed: 'Failed to load parking spots',
            uploadFailed: 'Failed to update ObjectIDs',
            updated: 'Updated',
            unknownSpotIds: 'Unknown spot IDs',
            duplicateInFile: 'Duplicate ObjectID in file',
            unnumbered: 'Unnumbered',
            id: 'Spot ID',
            searchPlaceholder: 'Search by Spot ID, Spot number or ObjectID',
            noResults: 'No matches',
            pageOf: 'Page {{page}} of {{total}}',
            previewLoading: 'Calculating preview…',
            previewFailed: 'Failed to generate preview',
            previewTitle: 'Preview — what will happen?',
            confirmUpload: 'Confirm upload',
            xlsxParseError: 'The file could not be read. Make sure it is a valid Excel file.',
            noRowsFound: 'No valid rows found in the file (need column "Spot ID").',
            previewSummary: '{{total}} rows analyzed — {{changes}} will result in changes.',
            previewSummarySet: '{{count}} spots get a new ObjectID (was empty).',
            previewSummaryChange: '{{count}} spots have their ObjectID changed.',
            previewSummaryClear: '{{count}} spots have their ObjectID cleared.',
            previewSummaryRename: '{{count}} numbered spots are renamed.',
            previewSummarySetAndRename: '{{count}} spots have BOTH ObjectID and name changed.',
            previewSummaryNoChange: '{{count}} rows have no changes.',
            previewSummarySkipUnknown: '{{count}} parking spot IDs do not exist in this area — skipped.',
            previewSummaryDupObj: '{{count}} ObjectID duplicates within the file — skipped.',
            previewSummaryDupSpot: '{{count}} spot number duplicates within the file — skipped.',
            previewSummarySkipUnnumbered: '{{count}} unnumbered spots cannot be renamed (only ObjectID updated).',
            previewSummaryErrors: '{{count}} rows have errors.',
            previewColAction: 'Action',
            previewColExplanation: 'What will happen',
            actionSet: 'Set ObjectID',
            actionChange: 'Change ObjectID',
            actionClear: 'Clear ObjectID',
            actionRename: 'Rename spot',
            actionClearSpot: 'Clear spot number',
            actionSetAndRename: 'Set + rename',
            actionNoChange: 'No change',
            actionSkipUnknown: 'Skip — unknown spot',
            actionSkipDupObj: 'Skip — duplicate ObjectID',
            actionSkipDupSpot: 'Skip — duplicate name',
            actionSkipUnnumbered: 'Cannot rename unnumbered',
            actionError: 'Error',
            kpiTotal: 'Total',
            kpiChanges: 'Changes',
            kpiNoChange: 'Unchanged',
            kpiIssues: 'To address',
            filterLabel: 'Show:',
            filterAll: 'All',
            filterChanges: 'Changes',
            filterNoChange: 'Unchanged',
            filterIssues: 'To address',
            filterNoResults: 'No rows match the selected filter.',
          },
          discountCodes: {
            title: 'Discount codes',
            searchPlaceholder: 'Search by code or campaign',
            createButton: 'Create discount code',
            createTitle: 'Create new discount code',
            editTitle: 'Edit discount code',
            tabActive: 'Active',
            tabInactive: 'Inactive',
            tabDeleted: 'Deleted',
            code: 'Code',
            campaignName: 'Campaign name',
            percent: 'Discount (%)',
            maxHours: 'Max hours per booking',
            maxHoursLabel: 'Max parking time per booking (hours)',
            unlimitedHint: '0 or empty = unlimited',
            maxUsages: 'Max total usages',
            validFrom: 'Valid from',
            validUntil: 'Valid until',
            status: 'Status',
            usages: 'Usages',
            actions: 'Actions',
            save: 'Save',
            edit: 'Edit',
            deactivate: 'Deactivate',
            reactivate: 'Reactivate',
            delete: 'Delete',
            restore: 'Restore',
            deleteConfirm: 'Are you sure you want to delete "{{code}}"?',
            deletedAt: 'Deleted at',
            totalDiscounted: 'Total discounted',
            usageLog: 'Usage log',
            date: 'Date',
            bookingId: 'Booking ID',
            originalAmount: 'Original',
            discounted: 'Discount',
            final: 'Final',
            stats: 'Statistics',
            monthlyBreakdown: 'Last months',
            month: 'Month',
            noUsagesYet: 'Not used yet',
            viewBookings: 'View bookings with this code',
            discountCodeColumn: 'Discount code',
            createdAt: 'Created',
            status_Active: 'Active',
            status_Expired: 'Expired',
            status_FullyUsed: 'Fully used',
            status_NotStarted: 'Not started',
            status_Inactive: 'Inactive',
            status_Deleted: 'Deleted',
            codeRequired: 'Code is required',
            invalidPercent: 'Discount % must be between 1 and 100',
            errCodeRequired: 'Code is required',
            errCodeFormat: 'Code can only contain A–Z, 0–9, _ and - (max 32 chars)',
            errCampaignTooLong: 'Campaign name max 100 chars',
            errPercentRequired: 'Discount % is required',
            errPercentInteger: 'Discount % must be an integer',
            errUsagesInvalid: 'Max usages must be 0 or greater (0 = unlimited)',
            errHoursInvalid: 'Max hours must be 0 or greater (0 = unlimited)',
            errUntilBeforeFrom: 'Valid until must be after Valid from',
            loadFailed: 'Failed to load discount codes',
            loadUsagesFailed: 'Failed to load usages',
            created: 'Discount code created',
            createFailed: 'Failed to create discount code',
            updated: 'Discount code updated',
            updateFailed: 'Failed to update discount code',
            deactivated: 'Discount code deactivated',
            reactivated: 'Discount code reactivated',
            deleted: 'Discount code deleted',
            deleteFailed: 'Failed to delete discount code',
            restored: 'Discount code restored',
            restoreFailed: 'Failed to restore discount code'
          },
          getStartedWidgets: {
            welcome: "Welcome to AirPark!",
            hello: "Hi {{name}}!",
            intro: "This is your start page, as you begin to activate and offer parkings we'll be able to provide you with data and key insights here.",
            letsgo: "Let's get started!",
            createParkingAreasTitle: "Parking areas",
            createParkingAreasDescription: "Parking areas are locations where you can add parking spots with specific features.",
            addBasicInformationTitle: "Basic information",
            addBasicInformationDescription: "Add some basic information about your parkings. Such as availability, base price, and so forth.",
            addPriceRulesAndRewardTitle: "Price rules and rewards",
            addPriceRulesAndRewardDescription: "You can create custom price rules to increase your revenue at peak hours. You can also create rewards for your customers when they use your parkings!",
            toParkingAreas: 'To parking areas'
          },
          parkingAreas: {
            noAreasTitle: "No areas added",
            noAreasDescription: "Start by adding an area which contains one or more parkings.",
            areas: "Areas",
            addArea: "Add area",
            pin: "Pin",
            name: "Name",
            parkings: "Parkings",
            noParkingAreas: "No parking areas",
            videoInstructionsDescription: "Watch our video tutorial on how to add a parking area.",
          },
          topBar: {
            organizations: "Organizations",
            addOrganization: "Create organization",
            logout: 'Logout'
          },
          createParkingArea: {
            name: "Name",
            basics: "Area information",
            hour: "hour",
            day: "day",
            oneTimeFee: "one-time fee",
            position: "Position",
            basePrice: "Base price",
            positionDescription: "Find area, zoon in, and then draw the area by adding corners of the area.",
            removePosition: "Remove area",
            detailsHeader: "Number of spots and features",
            detailsDescription: "State how many spots are outdoors and indoors. Also state what kind of features are available.",
            indoors: "Indoors",
            outdoors: "Outdoors",
            chargingPost: "Charging box",
            fenced: "Fenced",
            disabilityParking: "HKP",
            heaterCharging: "Engine heater",
            caravan: "Caravan",
            mobileHome: "Garage",
            information: "Information",
            photo: "Photo",
            totalNumberOfParkingSpots: "Total {{totalNumberOfParkingSpots}} parking spots",
            confirm: 'Confirm parking area',
            confirmDescription: 'We need one or more documents that validates that it is OK to add this parking area. Please upload the documents below. AirPark will then review these and confirm the authenticity before the parking area will be available for end-users. Thanks!',
            address: 'Address',
            noAddress: 'Draw an area on the map to set the address of the parking area',
            changeAddress: 'Not correct address? Enter the address manually',
            city: 'City',
            zipCode: 'Zip code',
            country: 'Country',
            search: 'Search...',
            notnumbered: 'Not numbered',
            numbered: 'Numbered',
            add: 'Add',
            numberedTitle: 'Are the parking spots numbered?',
            features: 'Features',
            from: 'From',
            to: 'To',
            parkingSpots: 'Parking spots',
            addParkingSpots: 'Add parking spots',
            parkingAreaDescription: 'Description',
            creatingParkingArea: 'Creating...',
            parkingAreaDetailsTitle: 'Description',
            parkingAreaDetailsDescription: 'Provide any relevant information about the parking area.',
            inReviewTitle: '{{name}} sent in for approval',
            inReviewDescription: 'AirPark will now review the documentation provided and your parking area. In the meantime you are free to set-up price rules and availability for the parking area.',
            amount: 'Number of parking spots',
            somethingWentWrongTitle: 'Something went wrong',
            somethingWentWrongDescription: 'Something went wrong when the parking area was supposed to be created. Please try again. Please contact AirPark support if the problem persists.',
            fileNotValidTitle: 'File not valid',
            fileNotValidDescription: 'The file was not valid. Please use PNG, JPG, JPEG or GIF with a maximum size of 10MB.',
            floor: "Floor",
          },
          parkingAreaMap: {
            removeArea: 'Remove area'
          },
          parkingArea: {
            edit: 'Edit',
            description: 'Description',
            noDescription: 'No description for {{name}}',
            free: 'free',
            add: 'Add',
            yes: 'Yes',
            no: 'No',
            downloadSigns: 'Download signs',
            notNumbered: 'Not numbered',
            features: 'Features',
            locationSpecific: 'Location specific',
            floor: 'Floor',
            unspecified: 'Unspecified',
            indoors: 'Indoor',
            outdoors: 'Outdoor',
            fenced: 'Fenced',
            disabilityParking: "HKP",
            heaterCharging: "Engine heater",
            caravan: "Caravan",
            mobileHome: "Garage",
            hasChargingPost: 'Charging',
            id: 'Id',
            objectId: 'ObjectID',
            number: 'Number',
            parkings: 'Parking spots',
            awaitingApprovalTitle: '{{name}} is in review',
            awaitingApprovalDescription: '{{name}} is being reviewed by AirPark and is awaiting approval. In the meantime you can add parking spots, price rules and availablity. The parking area will not be available in the app until AirPark has validated that ownership of the area.',
            availability: 'Availability & Pricing',
            outsideAvailabilityHours: 'Outside availability hours',
            updatedTitle: 'Updated',
            updatedDescription: 'Parking area is now updated',
            parkingNotAllowed: 'Parking not allowed',
            parkingFree: 'Free parking',
            startDate: 'Start date',
            endDate: 'End date',
            period: 'Period',
            days: 'Days',
            time: 'Time',
            parkingSpots: 'Parking spots',
            availableFor: 'Available for',
            price: 'Price',
            allDays: 'Any',
            public: 'Public',
            allParkingSpots: 'Any',
            specificDays: 'Specific days',
            community: 'Community',
            specificSpots: 'Specific spots',
            removePriceRuleSetTitle: 'Delete?',
            removePriceRuleSetDescription: 'Are you sure you want to remove the price & availability row?',
            removedPriceRuleSetTitle: 'Deleted',
            removedPriceRuleSetDescription: 'Successfully deleted price rule set',
            missingPriceRuleSets: 'You need to add price and availability if you want customers to be able to book parkings in the AirPark app.',
            removedParkingSpotTitle: 'Deleted',
            removedParkingSpotDescription: 'Successfully deleted parking spot',
            removeParkingSpotTitle: 'Delete?',
            removeParkingSpotDescription: 'Are you sure you want to delete the parking spot?',
            approvedTitle: 'Approved',
            approvedDescription: 'The parking area is now approved by AirPark. Add price rules and availability if you want to make it available to book in the AirPark app.',
            asDefinedByPeriod: 'As defined by the period',
            removeParkingAreaTitle: 'Remove area',
            removeParkingAreaDescription: 'Are you sure you want to remove the parking area? This cannot be undone!',
            ongoing: 'Ongoing',
            removedParkingAreaTitle: 'Removed',
            removedParkingAreaDescription: 'Parking area was removed',
            videoInstructions: 'How to configure availability and pricing',
            videoInstructionsDescription: 'Watch this video to learn how to configure availability and pricing for your parking area.',
          },
          addPriceRuleSet: {
            title: 'Add price & availability',
            description: 'Name / description',
            from: 'From',
            to: 'To',
            pickParkingSpots: 'Choose parking spots',
            all: 'All',
            specificSpots: 'Specific',
            selectedNumberOfSpots: '{{number}} spots selected',
            onWeekdays: 'On weekdays',
            public: 'Public',
            community: 'Community',
            availability: 'Days',
            betweenDates: 'All',
            specificDays: 'Specific days',
            save: 'Save',
            between: 'Between',
            errorTitle: 'Something went wrong',
            errorName: 'You need to enter a description/name',
            errorParkingSpots: 'No parking spots selected',
            errorDateRange: 'From date must be smaller than to date',
            errorPrice: 'Price cannot be empty or 0',
            priceRuleSetUpdatedTitle: 'Updated',
            priceRuleSetUpdatedDescription: '{{name}} is now updated',
            priceRuleSetAddedTitle: 'Added',
            priceRuleSetAddedDescription: '{{name}} is now added for the parking area',
            price: 'Price',
            availableFor: 'Available for',
            limitNumberOfHoursParkingIsAllowed: 'Set max parking time?',
            maxParkingTimeInHours: 'Max parking time in hours',
            tooltipAvailability: 'Choose Between dates if the price and availability is for the whole period. Choose Recurring days if the price and availability is for specific days of the week and hours of the day – e.g. Mon - Fri 1pm - 6pm.',
            tooltipDescription: 'Give the price and availablity a name or description. This is only visible for you in the portal and won\'t be shown in the AirPark app.',
            editTitle: 'Edit price & availablity',
            noEndDate: "Until further notice",
            ongoing: 'ongoing',
            chooseCommunity: 'Choose community',
            noCommunitiesTitle: 'No communities',
            noCommunitiesDescription: 'No communities available for the parking area. Go to the communities section to create a community.',
            recurring: 'Recurring',
            recurringTo: 'Recurring to',
            between: 'Between',
            and: 'and',
            overlapMessage: 'There is already an availability set that overlaps with the given date range'
          },
          selectParkingSpotsModal: {
            selectParkingSpots: 'Select parking spots',
            selectParkingSpot: 'Select parking spot',
            yes: 'Yes',
            no: 'No',
            notNumbered: 'Not numbered',
            features: 'Features',
            locationSpecific: 'Location specific',
            id: 'Id',
            objectId: 'ObjectID',
            number: 'Number',
            numberOfParkingSpotsSelected: '{{number}} parking spots selected',
            noParkingSpotsAvailable: 'No parking spots available',
            floor: 'Floor',
            price: 'Price',
            unspecified: 'Unspecified',
            provideNumberSeries: 'To create numbered spots, you must enter a valid \'From\' number',
            searchPlaceholder: 'Search by Spot ID, ObjectID, Spot number or Floor',
            noSearchResults: 'No spots match the search'
          },
          selectCommunitiesModal: {
            selectCommunities: 'Select Communities',
            selectCommunity: 'Select Community',
            id: 'Id',
            name: 'Community name',
            numberOfCommunitiesSelected: '{{number}} communities selected',
            numberOfMembers: 'Number of members',
            noCommunitiesAvailable: 'No communities available',
          },
          editParkingSpotModal: {
            editParkingSpot: 'Edit parking spot',
            parkingSpotActive: 'Parking spot available',
            parkingSpotDisabled: 'Parking spot unavailable',
            outdoors: 'Outdoors',
            indoors: 'Indoors',
            fenced: 'Fenced',
            chargingPost: 'Charging box',
            features: 'Features',
            description: 'Description',
            positionDescription: 'If the parking spot is numbered you can give it an exact position. Place the pin on the parking area where the parking spot is located.',
            positionSpecific: 'Numbered',
            position: 'Position',
            floor: 'Floor',
            number: 'Number',
            objectId: 'ObjectID',
            objectIdDescription: 'The property owner\'s own identifier for this parking spot.',
            removePin: 'Remove pin',
            parkingSpotUpdatedTitle: 'Updated',
            parkingSpotUpdatedDescription: 'Parking spot is now updated',
            provideNumberSeries: 'To create this spot as numbered, you must enter a valid number'
          },
          addParkingSpotsModal: {
            title: 'Add parking spots',
            addedParkingSpotsTitle: 'Added',
            addedParkingSpotsDescription: 'Parking spots added to the parking area'
          },
          editParkingArea: {
            approvalRequiredTitle: 'Approval required',
            approvalRequiredDescription: 'A new approval is required from AirPark if the parking area\'s information is updated. During the approval process it won\'t be possible to issue any new permits or for customers to make any new bookings in the AirPark app.',
            description: 'Description',
            updatedTitle: 'Updated',
            updatedDescription: 'The parking area is now updated.',
            updatedDescriptionRequiresApproval: 'The parking area is now updated. AirPark will review the changes and get back to you as soon as possible.',
            uploadImages: 'Upload images',
            parkingAreaHasNoImages: 'The parking area has no images. Upload images and save to create a better presentation of the area in the AirPark app.',
            fieldsMissingTitle: 'Fields missing',
            fieldsMissingDescription: 'One or more fields are missing. Please fill in all fields and try again.',
          },
          createPermitPage: {
            createTitle: 'Create permit',
            issueTitle: 'Issue permit',
            activateManualPermit: 'Activate manual permit',
            manualActivation: 'Manual activation',
            manualActivationEditModeTooltip: 'Cannot be modified in edit mode',
            manualActivationTooltip: 'You will need to insert all details about the user with the permit and will not have option to add phone number.',
            phoneNumber: 'Recipient mobile phone number',
            phoneNumberTooltip: 'A text message with a link to the permit will be sent to the recipient. The permit will be valid first after a successful payment.',
            description: "Description",
            descriptionPlaceholder: "e.g. Jane Doe, Acme Company",
            descriptionTooltip: "Give the permit a description. This will only be visible in the portal. The recipient\'s name will be displayed on the permit after the permit has been activated.",
            chooseParkingSpot: "Choose parking spot",
            allParkingSpots: "Area parking",
            specificParkingSpots: "Specific spots",
            notNumbered: 'Not numbered',
            period: 'Days',
            betweenDates: 'All',
            specificDays: 'Specific days',
            tooltipPeriod: 'When choosing all days the permit is valid throughout the selected period for any day in the period. Specific days allows to specify days and hours when the permit should be valid within the selected period – e.g. Mon-Fri 7am-6pm.',
            spotSelected: 'Spot selected',
            noSpotSelected: 'No spot selected',
            from: 'From',
            to: 'To',
            onWeekdays: 'On weekdays',
            between: 'Between',
            isSublettingAllowed: 'Is subletting allowed',
            canBeSublettedTo: 'Can be subletted to',
            isSublettingAllowedDescription: 'Choose if the permit is allowed to be subletted. The permit can be restricted to only subletting within a community.',
            isSublettingAllowedMarketplaceDescription: 'Choose if the permit is allowed to be subletted.',
            community: 'Community',
            everyone: 'Anyone',
            invoicedBy: 'Invoiced by',
            externally: 'Other party',
            price: 'Price',
            invoicedByTooltip: 'Choose how payments should be handled. AirPark can allow payments for the permit directly in the AirPark app and update the permit\'s status accordingly. If a third party manages the payments the status of the permit must be updated manually.',
            invoicedExternallyTitle: 'Other party',
            invoicedExternallyDescription: 'The payments are managed by a third party. Any administration in regards to payments of the invoice must be handled manually.',
            noEndDate: 'Ongoing',
            permitCreatedTitle: 'Permit created',
            permitActivatedTitle: 'Permit activated',
            permitActivatedDescription: 'The permit has been manually activated and is now valid.',
            permitCreatedManualActivationDescription: 'The permit has been created and need to be manually activated',
            permitCreatedDescription: 'The permit has been created and a text message has been sent to {{phone }} with an invitation link. When the recipient has accepted the permit their name will be displayed on the permit.',
            editTitle: 'Edit permit',
            permitUpdatedTitle: 'Updated',
            permitUpdatedDescription: 'Permit updated.',
            marketplaceAvailability: 'Available on the marketplace for',
            reAddToMarketplace: 'Re-add permit to marketplace.',
            reAddToMarketplaceTooltip: 'Choose if permit should be re-added to marketplace on cancel/revoke. This setting can be overridden during revoke action.',
            requiresContractCode: 'Require contract code',
            requiresContractCodeTooltip: 'If enabled, users must enter a valid contract code provided by the property owner to claim this permit.',
            marketplacePermitCreatedTitle: 'Permit created',
            marketplacePermitCreatedDescription: 'Permit is created and available on the marketplace.',
            marketplacePermit: 'Choose if the permit should be available to purchase by anyone or if it should only be available to purchase by members of a community.',
            addUserToCommunity: 'Add recipient to communities',
            addUserToCommunityTooltip: 'Choose if the user should be added to the communities created for the parking area when the permit is accepted.',
            noCommunitiesFoundTitle: 'No communities found',
            noCommunitiesFoundDescription: 'The parking area has no communities. Create a community in the parking area\'s settings.',
            userWillBeAddedToCommunitiesTitle: 'Communities',
            userWillBeAddedToCommunitiesDescription: 'The user will be added to the following communities: {{communities}}',
            pleaseChooseCommunities: 'Please choose communities',
            issue: 'Issue permit',
            parkingSpots: 'Parking spots',
            specialRequests: 'Special requests',
            contractCode: 'Contract code',
            noContractCode: 'No contract code',
          },
          permitsPage: {
            permitsPageTitle: 'Permits',
            permitsPageDescription: 'Administer and issue permits for the parking area or specific parking spots. When a permit is issued the recipient receives a text message with an invitation link.',
            addPermitTitle: 'Permit',
            createPermit: 'Create',
            bulkCreate: 'Bulk create',
            downloadCSV: 'Download CSV',
            expired: 'Expired',
            unpaid: 'Unpaid',
            cancelled: 'Canceled',
            activePermits: 'Active',
            parkingSpotsWithoutPermits: 'Parking spots without permits',
            permitsInMarketplace: 'Permits in marketplace',
            videoInstructionsDescription: 'Watch our video on how to issue parking permits',
            selectColumns: 'Select columns for CSV',
            manualActivateTitle: 'Manual permit activation',
            manualActivateDescription: 'The manual permit has been successfully created.',
          },
          contractCodesPage: {
            title: 'Contract codes',
            description: 'Manage contract codes for marketplace permits. Users can claim a permit by entering a valid contract code.',
            tabOverview: 'Overview',
            tabUpload: 'Upload codes',
            tabScheduled: 'Scheduled transitions',
            totalCodes: 'Total codes',
            usedCodes: 'Used codes',
            availableCodes: 'Available codes',
            availablePermits: 'Available permits',
            uploadTitle: 'Upload codes',
            selectPermit: 'Select permit',
            uploadCsv: 'Upload Excel file (.xlsx)',
            downloadTemplate: 'Download Excel template',
            helpMobilnumber: 'Mobilnummer: if set, the permit is activated automatically on the user with that phone number (SMS/push is sent).',
            helpRegnumber: 'Regnummer: pre-fills the vehicle. If empty when mobilnumber is set, the customer must add the vehicle in the app — otherwise risk of a parking control fine.',
            csvPlaceholder: 'Enter one code per line, or upload a CSV file...',
            noPermitsWithContractCode: 'No permits with contract code requirement',
            selectPermitAndCodes: 'Please select a permit and enter codes',
            noCodesFound: 'No codes found in the input',
            uploadSuccess: '{{added}} codes added, {{skipped}} skipped (duplicates)',
            codesList: 'Codes',
            code: 'Code',
            permit: 'Permit',
            usedBy: 'Used by',
            usedAt: 'Used at',
            noCodes: 'No contract codes found. Upload codes above.',
            inactive: 'Inactive',
            used: 'Used',
            available: 'Available',
            reset: 'Reset',
            codeReset: 'Code has been reset and can be used again',
            codeRevoked: 'Code has been revoked',
            issue: 'Issue',
            issueTitle: 'Issue permit',
            issueDescription: 'Issue a permit using code: {{code}}',
            noAvailablePermits: 'No available marketplace permits with contract code requirement. Create a marketplace permit first.',
            availablePermitsInfo: '{{count}} permits available to issue',
            recipientPhone: 'Recipient mobile number',
            phoneRequired: 'Mobile number is required',
            issueSuccess: 'Permit issued to {{userName}}',
            showInactive: 'Show inactive ({{count}})',
            reactivate: 'Reactivate',
            codeReactivated: 'Code has been reactivated',
            delete: 'Delete',
            deleteConfirm: 'Are you sure you want to permanently delete this code? This cannot be undone.',
            codeDeleted: 'Code has been permanently deleted',
            inactiveCodes: 'Inactive codes',
            inactivate: 'Inactivate',
            selectPermitSpot: 'Select spot',
            noPermitSelected: 'Please select a spot',
            licensePlate: 'License plate',
            licensePlateRequired: 'License plate is required',
            uploadFormat: 'One code per line. Optionally add a phone number in the second column and a registration plate in the third column (comma, semicolon or tab separated). Phone numbers must include country code (e.g. +46701234567) or start with 0 (automatically converted).',
            uploadFormatExample: 'Examples: "A101" or "A101,+46701234567" or "A101,+46701234567,ABC123"',
            notEnoughPermits: 'The file contains {{phoneCount}} phone numbers but only {{available}} permits are available. Create more permits or remove phone numbers from the file.',
            csvGuide: 'How to export from Excel',
            csvGuideStep1: 'Open the file in Excel',
            csvGuideStep2: 'Click File → Save As',
            csvGuideStep3: 'Choose format: CSV UTF-8 (Comma delimited) (.csv)',
            csvGuideStep4: 'Click Save',
            csvGuideAlt: 'Alternatively, upload the Excel file (.xlsx) directly — the portal reads it automatically.',
            previewCodes: '{{count}} codes found.',
            duplicatesWarning: '{{count}} duplicate codes detected — they will not be imported.',
            previewLoading: 'Calculating preview against system data…',
            previewError: 'Could not generate preview. Try again or remove rows.',
            xlsxParseError: 'The file could not be read. Make sure it is a valid Excel file.',
            previewSummaryHeader: 'Will process {{total}} rows for {{area}}',
            previewSummaryAdd: '{{count}} new open codes will be added (anyone can claim them).',
            previewSummaryIssue: '{{count}} permits will be issued ({{existing}} to existing users, {{stub}} to stub users that must register in the app).',
            previewSummaryVehicles: '{{count}} new vehicle records will be created.',
            previewSummaryDupFile: '{{count}} duplicates within the file will be skipped.',
            previewSummaryDupDb: '{{count}} codes that already exist on the area will be skipped.',
            previewSummaryErrors: '{{count}} rows are invalid (missing code, etc).',
            previewColAction: 'Action',
            previewColCode: 'Code',
            previewColExplanation: 'What will happen',
            actionAdd: 'Add (open)',
            actionAddAndIssue: 'Add + issue',
            actionAddIssueCreateUser: 'Add + issue + new user',
            actionSkipDupFile: 'Skip — duplicate in file',
            actionSkipDupDb: 'Skip — already exists',
            actionError: 'Error — skipped',
            searchPermitPlaceholder: 'Search by Spot ID, spot number or ObjectID',
            searchingPermits: 'Searching…',
            permitsShownOf: '{{shown}} of {{total}} permits shown',
            spotIdLabel: 'Spot ID',
            spotNumberLabel: 'Spot',
            objectIdLabel: 'ObjectID',
            chooseFile: 'Choose file (.csv, .xlsx)',
            removeFile: 'Remove file',
            typeManually: 'Or type/paste codes manually',
            manualInput: 'Manual input',
            manualInputFormatHeading: 'Format (one per line):',
            manualInputFormatExample1: 'code only (open — customer enters it in the app)',
            manualInputFormatExample2: 'code + mobile number (activated automatically)',
            manualInputFormatExample3: 'code + mobile + plate number (pre-filled vehicle)',
            columnMapping: 'Column mapping',
            hasHeader: 'File has header row',
            codeColumn: 'Code column',
            phoneColumn: 'Phone number column',
            noPhoneColumn: 'None',
            phoneValidationOk: '{{count}} valid phone numbers',
            phoneValidationWarning: '{{valid}} valid phone numbers, {{invalid}} unrecognised values (will be skipped)',
            previewRows: 'Preview',
            previewRowsMore: '... and {{count}} more rows',
            uploadWithPhones: '{{phoneCount}} phone numbers detected — permits will be issued automatically.',
            issueSuccessCount: '{{count}} permits issued successfully.',
            uploadStep1Title: 'Format',
            uploadStep2Title: 'Pick file',
            uploadStep3Title: 'Map columns',
            uploadStep4Title: 'Preview',
            uploadStep5Title: 'Done',
            uploadStep1Heading: 'How the upload works',
            uploadStep2Heading: 'Upload Excel file',
            uploadStep2Description: 'Choose the Excel file (one code per row), or type/paste codes manually.',
            uploadStep3Heading: 'Map columns',
            uploadStep3Description: 'Confirm which columns hold the code, phone number and registration plate.',
            uploadStep4Heading: 'Preview',
            uploadStep4Description: '{{count}} rows ready to be processed. Review the result against system data, then upload.',
            uploadContinue: 'Continue',
            uploadBack: 'Back',
            uploadAnother: 'Upload another',
            uploadDoneTitle: 'Codes uploaded',
            fileLoadedRows: '{{count}} rows loaded',
            filterLabel_available: 'Available only',
            filterLabel_used: 'Used only',
            filterLabel_scheduled: 'Scheduled transitions only',
            filterLabel_inactive: 'Inactive only',
            clearFilter: 'Clear filter',
            scheduledTransitions: 'Scheduled transitions',
            queued: 'Queued',
            scheduleTransition: 'Schedule transition',
            cancelTransition: 'Cancel transition',
            cancelTransitionConfirm: 'Are you sure you want to cancel the scheduled transition?',
            transitionCancelled: 'Scheduled transition has been cancelled',
            scheduleTransitionTitle: 'Schedule tenant transition',
            scheduleTransitionDescription: 'Schedule a tenant transition for code: {{code}}. The code is currently used by {{currentUser}}.',
            newTenantPhone: 'New tenant mobile number',
            activeDate: 'Activation date',
            activeDateRequired: 'Activation date is required',
            scheduleTransitionInfo: 'At midnight on the selected date, the code will automatically be transferred to the new tenant and the permit will be reassigned.',
            schedule: 'Schedule',
            scheduleSuccess: 'Transition scheduled for {{userName}} on {{date}}',
            editTransition: 'Edit',
            editTransitionTitle: 'Edit scheduled transition',
            editTransitionDescription: 'Edit the scheduled transition for code: {{code}}. Currently queued: {{currentQueued}}.',
            saveChanges: 'Save changes',
            lookupVehicles: 'Look up vehicles',
            vehicle: 'Vehicle (optional)',
            noVehicle: 'No vehicle — user adds in app',
            addNewVehicle: '+ Add new vehicle',
            add: 'Add',
            vehicleCreated: 'Vehicle {{plate}} added',
            regPlateColumn: 'Registration plate column',
            uploadWithRegPlates: '{{count}} registration plates detected — vehicles will be created automatically.',
            queuedUser: 'Queued user',
            licensePlateOptional: 'License plate (optional)',
            regPlateOptionalInfo: 'The user will be asked to enter a license plate when they log in to the app.',
            userNotRegistered: 'This user does not have the AirPark app. The permit will be created and the user will be prompted to register and enter a license plate when they open the app.',
            resetConfirm: 'Are you sure you want to reset this code? The code will become available for a new user. Note: the permit associated with this code will remain active — please end the permit manually if needed.',
            vehicleCreateError: 'Could not create the vehicle. Please check the license plate and try again.',
          },
          inputPhoneNumber: {
            chooseCountryRegion: 'Choose country/region'
          },
          bulkCreateModal: {
            title: 'Bulk create marketplace permits',
            communityExtIdsPlaceholder: 'Community ExtIds (comma-separated)',
            selectSpots: 'Select parking spots',
            selectAll: 'Select all',
            deselectAll: 'Deselect all',
            noSpotsAvailable: 'No available parking spots (all spots already have permits).',
            noSpotsSelected: 'Select at least one spot.',
            spotsSelected: '{{count}} spots selected',
            settings: 'Permit settings',
            paymentManual: 'Payment handled outside AirPark',
            price: 'Price',
            startDate: 'Start date',
            openEnded: 'Open-ended (no end date)',
            endDate: 'End date',
            requiresContractCode: 'Requires contract code',
            communityOnly: 'Community only',
            subletting: 'Subletting allowed',
            createButton: 'Create {{count}} permits',
            created: '{{count}} permits created successfully.',
            priceRequired: 'Price is required when payment is not handled manually.',
          },
          smsStatus: {
            failed: 'Not delivered',
            retrying: 'Sending…',
            pending: 'Pending',
            retryingTip: 'The SMS has not been delivered yet — the system is retrying.',
            pendingTip: 'The SMS invitation has not been sent yet.',
            reason: {
              landline: 'The number is a landline and cannot receive SMS. Ask the recipient for a mobile number.',
              invalid: 'The number is invalid or incorrectly entered. Check the number and try again.',
              unsubscribed: 'The recipient has opted out of SMS (replied STOP).',
              unreachable: 'The number cannot be reached via SMS.',
              unknown: 'The SMS could not be sent.',
            },
          },
          permitTable: {
            notAcceptedYet: 'Pending',
            name: 'Name',
            description: 'Description',
            spotIdentifier: 'Spot identifier',
            objectId: 'ObjectID',
            timePeriod: 'Period',
            id: 'Id',
            status: 'Status',
            firstName: 'First name',
            lastName: 'Last name',
            email: 'E-mail',
            phoneNumber: 'Phone number',
            licensePlateNumber: 'License plate',
            period: 'Period',
            time: 'Hours',
            price: 'Price',
            subletting: 'Subletting',
            duplicate: 'Duplicate',
            revoke: 'Revoke',
            days: 'Days',
            parkingArea: 'Whole area',
            noPermits: 'No permits issued. Click Create to issue a permit.',
            noMarketplacePermits: 'No permits available on the marketplace.',
            noPermitsFound: 'No permits found',
            active: 'Active',
            pending: 'Invitation sent',
            upcoming: 'Upcoming',
            allowed: 'Allowed',
            notallowed: 'Not allowed',
            invoicedBy: 'Invoiced by',
            thirdParty: 'Other',
            revokePermitTitle: 'Revoke permit?',
            revokePermitDescription: 'The permit will be revoked on {{date}}. Note that if the permit should have a different end date, you can set it below. {{note}}',
            revokePermitDescriptionWithoutDateOption: 'The permit will be revoked on {{date}}. {{note}}',
            revokePermitEndDateNote: 'Note that the current end date of the permit is {{endDate}}.',
            revokedPermitTitle: 'Permit revoked',
            revokedPermitDescription: 'The permit is now revoked and not valid anymore.',
            expired: 'Expired',
            ongoing: 'Ongoing',
            marketplace: 'Available on marketplace',
            availability: 'Available for',
            community: 'Community',
            everyone: 'Public',
            deletePermitTitle: 'Delete?',
            deletePermitDescription: 'This will delete the permit.',
            deletedTitle: 'Deleted',
            deletedDescription: 'The permit was deleted.',
            reAddToMarketplace: 'Re-add to marketplace',
            reAddToMarketplaceTooltip: 'The permit will be added to the marketplace right away with a start date {{startDate}}.',
            isFromMarketplace: 'Is a marketplace permit',
            revokeDate: 'Revoke date',
            revokedOrCancelled: 'Revoked/Cancelled',
            manualactivation: 'Manual activation',
            contractCode: 'Contract code',

          },
          permitHistory: {
            menuItem: 'Change log',
            title: 'Change log',
            selectedPermit: 'Permit',
            by: 'By',
            empty: 'No changes have been logged for this permit yet.',
            error: 'Could not load the change log. Please try again.',
            vehicleChanged: 'Registration number changed {{from}} → {{to}}',
            permitEnded: 'Permit ended',
            inviteSent: 'Permit sent',
            actor: {
              customer: 'customer',
              operator: 'operator',
              'system-job': 'system',
            },
          },
          dropDownMultiSelector: {
            filter: 'Filter'
          },
          verifyEmailPage: {
            verifyEmailTitle: 'Confirm e-mail address',
            verifyEmailDescription: 'Confirm the e-mail adderss by clicking the link that was sent to {{email}}',
            emailCouldNotBeVerifiedTitle: 'Not verified',
            emailCouldNotBeVerifiedDescription: 'The e-mail address could not be verified. Please try again.',
            noVerificationEmailReceivedTitle: 'No e-mail received?',
            noVerificationEmailReceivedDescription: 'If you have not received an e-mail with a link to confirm your e-mail address, please check your spam folder. If you still have not received an e-mail, please try to request a new e-mail.',
            resendVerificationEmail: 'Resend e-mail',
            emailResentTitle: 'E-mail resent',
            emailResentDescription: 'A new e-mail with a link to confirm your e-mail address has been sent to {{email}}.'
          },
          login: {
            loginInProgress: 'Login in progress...'
          },
          permitMarketplacePage: {
            title: 'Marketplace',
            create: 'Create one',
            bulkCreate: 'Create many',
            description: 'Create parking permits that become available on the marketplace in the AirPark app. The parking permits can be made available for the general public or restricted to communities connected to the parking area.',
            showingOf: 'Showing {{from}}-{{to}} of {{total}}',
            previous: 'Previous',
            next: 'Next'
          },
          permitShare: {
            shareTitle: 'Share permit',
            shareDescription: 'Share a permit for the permit. The link can be shared by e-mail or using social media such as Facebook.',
            createdTitle: 'Permit created',
            createdDescription: 'The permit has been created and is available on the marketplace in the AirPark app. The permit can also be shared by e-mail or social media using the link below.',
            updatedTitle: 'Permit updated',
            updatedDescription: 'Permit updated and available on the marketplace in the AirPark app. The permit can also be shared by e-mail or social media using the link below.',
            copyLink: 'Copy the link to the clipboard',
            linkCopiedTitle: 'Copied',
            linkCopiedDescription: 'Link copied and available on the clipboard'
          },
          settingsPage: {
            title: 'Settings',
            description: 'Manage the settings for your organization.',
            name: 'Name',
            organizationNumber: 'Organization number',
            address: 'Address',
            zipCode: 'Zip Code',
            city: 'City',
            country: 'Country',
            phoneNumber: 'Phone number',
            email: 'Email',
            organizationUpdatedTitle: 'Updated',
            organizationUpdatedDescription: 'Organization was updated successfully',
            vatPercentage: 'VAT percentage',
            invoiceEmail: 'Invoice email',
            selfBilling: 'Self billing',
            selfBillingTooltip: 'Choose if you want to use self billing. Self billing means that you will pay the VAT manually. If you choose not to use self billing AirPark will pay the VAT for you, which will result in a higher fee for the service.',
            signAndSave: 'Sign and save',
            taxIdentificationNumber: 'Tax identification number',
            sign: 'Sign',
            signatureError: 'Signature invalid, please try again. If the problem persists please contact support. ({{supportEmail}})'
          },
          payoutSettingsPage: {
            stripeTitle: "Payout Account",
            stripeDescription: "AirPark uses the global payment provider Stripe for payouts.",
            stripeNotConfiguredTitle: "Stripe is not configured",
            stripeNotConfiguredDescription: "Stripe is not configured for your organization. Stripe needs to be configured in order to receive payouts.",
            configureStripe: "Configure Stripe",
            payoutDayOfMonthAndMinimumValueTitle: "Payout Day and Minimum Amount",
            payoutDayOfMonthAndMinimumValueDescription: "The day of the month when payouts are made and the minimum payout amount.",
            minimumPayoutValueErrorTitle: "Minimum payout amount is too low",
            minimumPayoutValueErrorDescription: "The minimum payout amount must be at least 300.",
            stripeConfiguredTitle: 'Stripe configured',
            stripeConfiguredDescription: 'Stripe is configured and linked to your AirPark account. Your organization can now accept payments.',
            payoutDayOfMonth: "Payout Day",
            minimumPayoutValue: "Minimum Payout Amount",
            minimumPayoutValueTooltip: "The minimum payout amount is the lowest amount that can be paid out. If the total revenue for a month is less than the minimum payout amount, the revenue will be rolled over to the next month.",
            dac7title: "DAC7",
            dac7description: "To enable AirPark to process payouts of your earnings, it is necessary for you to provide the above information.\n\nWe collect this information to ensure compliance with DAC7, the new EU law that came into effect on January 1, 2023, requiring us to report earnings from parking rentals to the Swedish Tax Agency.\n\nIf you wish to enable self-billing, you also need to provide your VAT registration number.\n\nBy providing this information and signing with BankID, you assure us that the information is correct and up-to-date.",
            sign: "Sign",
            dac7NotSignedTitle: "Not Signed",
            dac7NotSignedDescription: "The information has not been signed with BankID. To receive payouts and for self-billing, the information must be signed.",
            dac7SignedTitle: "Signed",
            dac7SignedDescription: "The information has been signed with BankID."
          },
          revenueSharingSettingsPage: {
            revenueSharingTitle: 'Revenue sharing',
            revenueSharingDescription: 'Configure the revenue sharing for your organization. The revenue sharing is used to calculate the revenue share for subletting. Please note that AirPark fees are not included in the revenue sharing.',
            revenueSharingSublettingTitle: 'Subletting',
            forYou: 'For you',
            subletter: 'Subletter',
            shareIsNotValidTitle: 'Share is not valid',
            shareIsNotValidDescription: 'The share is not valid. The sum of the shares must be 100.',
          },
          usersPage: {
            title: 'Manage users',
            description: 'Manage the users that have access to your organization. A portal administrator can see and administer everything in your portal, a sublessor can set your organization as recipient for payouts from subleasing.',
            users: 'Users',
            sublessors: 'Sublessors',
            portalAdministrators: 'Portal administrators',
            invites: 'Pending invites',
          },
          usersTable: {
            firstName: 'First name',
            lastName: 'Last name',
            email: 'E-mail',
            phone: 'Phone number',
            removeUserTitle: 'Remove user?',
            removeUserDescription: 'Are you sure you want to remove the user? The user will lose all access to this organization.',
            removedUserTitle: 'Removed user',
            removedUserDescription: 'Successfully removed user from organization',
            contact: "Contact",
            invitationStatus: "Invitation Status",
            sent: "Sent",
            accepted: "Accepted",
            accessLevel: "Access level",
            portalAdmin: "Portal admin",
            sublessor: "Sublessor",
          },
          invitesTable: {
            phone: 'Phone number',
            status: 'Status',
            issuedBy: 'Issued by',
            contact: 'Contact',
            noInvites: 'No invites pending',
            deleteInviteTitle: 'Delete invite?',
            deleteInviteDescription: 'Are you sure you want to remove the invite? This cannot be undone.',
            removedInviteTitle: 'Invite removed',
            removedInviteDescription: 'Successfully removed organization invite',
            sentAt: 'Sent at',
          },
          inviteUserModal: {
            title: 'Invite user',
            descriptionPortalAdmin: 'Send an invite to the user that you want to join your organization as a portal admin.',
            descriptionSublessor: 'Send an invite to the user that you want to join your organization as a sublessor.',
            userInvitedTitle: 'User invited',
            userInvitedDescription: 'User has been invited to join your organization.',
            portalAdmin: 'Portal admin',
            sublessor: 'Sublessor',
          },
          inviteSublessorModal: {
            userInvitedTitle: 'User invited',
            userInvitedDescription: 'User has been invited to join your organization as a sublessor.'
          },
          organizationInvitationPage: {
            youveBeenInvitedTitle: 'You\'ve been invited',
            youveBeenInvitedDescription: 'You\'ve been invited to join the {{organizationName}} organization.',
            useEmail: 'Login or sign-up with the e-mail address',
            acceptInvite: 'Accept invite',
            invitationNotFoundTitle: 'Not found',
            invitationNotFoundDescription: 'Sorry, the invitation was not found.',
            emailDoesNotMatchTitle: 'Wrong e-mail',
            emailDoesNotMatchDescription: 'The e-mail you\'re logged in with does not match the e-mail the invitation was sent to.',
            emailNotVerifiedTitle: 'Not verified',
            emailNotVerifiedDescription: 'You need to verify your e-mail before you can accept the invitation.'
          },
          communityPage: {
            title: 'Community',
            description: 'Communities can be used to create specific accessibility and pricing for parking areas, parking spots and pricing. It\'s also possible to connect with other communities to expand what your community members have access to.',
            communitiesTitle: 'Communities',
            addExistingCommunity: 'Add existing community',
            videoInstructionsDescription: 'Watch our video on what communities are and how to use them.',
          },
          createCommunityPage: {
            title: 'Create community',
            name: 'Name',
            description: 'Description',
            photos: 'Upload photo',
            photosTooltip: 'Upload an image that represents the community. Only a single image is allowed.',
            invalidFileType: 'Invalid file type. Allowed: JPG, PNG, GIF.'
          },
          communitiesTable: {
            name: 'Name',
            numberOfMembers: 'Number of members',
            description: 'Description',
            noCommunities: 'No communities',
            manageMembers: 'Manage members',
            noMembersManageMembers: 'No members. Invite members?',
            editCommunity: 'Edit community',
          },
          manageCommunityPage: {
            title: 'Manage community',
            uploadPhotos: 'Upload photo',
            photos: 'Photo',
            photosTooltip: 'Upload an image that represents the community. Only a single image is allowed.',
            noPhotos: 'No photo uploaded for this community',
            communityUpdatedTitle: 'Community updated',
            communityUpdatedDescription: 'Community was updated successfully'
          },
          manageCommunityMembersPage: {
            title: 'Manage community members',
            members: 'Members',
            inviteMember: 'Invite member',
            phoneNumber: 'Phone number',
            pendingInvites: 'Pending invitations',
            phoneNumberMissingTitle: 'Phone number missing',
            phoneNumberMissingDescription: 'A phone number is required to send an invitation',
            invitationSentTitle: 'Invitation sent',
            invitationSentDescription: 'Invitation sent to the member',
            sendPhoneInvitationTitle: 'Send phone invitation',
            sendPhoneInvitationDescription: 'Send an invitation to the member via SMS',
            createLinkInvitationTitle: 'Create invitation link',
            createLinkInvitationDescription: 'Create an invitation link that can be sent via e-mail or other channels',
            invitationLinkCreatedTitle: 'Invitation link created',
            invitationLinkCreatedDescription: 'Invitation link created. Copy the link and send it to the member.',
            noInvitationLinksCreated: 'No invitation links created',
          },
          communityMembersTable: {
            firstName: 'First name',
            lastName: 'Last name',
            phoneNumber: 'Phone',
            noMembers: 'No members'
          },
          communityInviteLinksTable: {
            link: 'Link',
            noLinks: 'No links'
          },
          connectedCommunitiesTable: {
            communityName: 'My community',
            connectedCommunityName: 'Connected with',
            noConnectedCommunities: 'No connected communities',
            deleteCommunityConnectionTitle: 'Delete community connection',
            deleteCommunityConnectionDescription: 'Are you sure you want to delete the community connection?',
            removedCommunityConnectionTitle: 'Community connection deleted',
            removedCommunityConnectionDescription: 'Successfully deleted community connection'
          },
          createConnectCommunityRequestModal: {
            title: 'Connect with community',
            stepsStart: 'To find a parking area and connect with a community, please follow these steps:',
            stepOne: 'Use the map to find a parking area and community you want to connect with. After selecting an area, a list of communities will appear.',
            stepTwo: 'Select the community that you want to connect with. If you have more than one community you need to select which of your community you want to create the connection for.',
            stepThree: 'Send the request to the community. The community will then be able to accept or decline the request.',
            stepsEnd: 'If the request is accepted, you will be able to see the community in the list of connected communities.',
            sendConnectRequest: 'Send connect request',
            selectCommunity: 'Select community to request a connection with',
            selectYourCommunity: 'Select which of your communities you want to request the connection for',
            noCommunitySelectedTitle: 'No community selected',
            noCommunitySelectedDescription: 'Use the map to find and select a parking area and community to connect with.',
            youCantConnectWithYourOwnParkingAreaTitle: 'That\'s not possible',
            youCantConnectWithYourOwnParkingAreaDescription: 'You can\'t connect with your own parking area.',
            noCommunitiesCreatedForParkingAreaTitle: 'No communities',
            noCommunitiesCreatedForParkingAreaDescription: 'There are no communities created for your parking area. Create a community first and then try again.',
            connectRequestSentTitle: 'Request sent',
            connectRequestSentDescription: 'Request sent to the community. The community will be able to accept or decline the request.',
          },
          communityConnectionsPage: {
            title: 'Community connections',
            description: 'On this page, you will find a list of requests that have been sent to your community, as well as requests that you have sent to other communities. You have the option to accept or decline these requests.',
            sentRequests: 'Sent requests',
            receivedRequests: 'Received requests',
            connectedCommunitiesTitle: 'Connected communities',
            connect: 'Connect',
            pendingRequests: 'Pending requests',
          },
          sentRequestsTable: {
            myCommunity: 'My community',
            sentToCommunity: 'Sent to community',
            noPendingRequests: 'No pending requests',
            deleteSentRequestTitle: 'Delete sent request',
            deleteSentRequestDescription: 'Are you sure you want to delete the sent request?',
            removedSentRequestTitle: 'Request deleted',
            removedSentRequestDescription: 'The sent request was deleted successfully',
          },
          receivedRequestsTable: {
            receivedFromCommunity: 'Received from community',
            myCommunity: 'My community',
            noPendingRequests: 'No pending requests',
            deleteReceivedRequestTitle: 'Delete received request',
            deleteReceivedRequestDescription: 'Are you sure you want to delete the received request?',
            removedReceivedRequestTitle: 'Request deleted',
            removedReceivedRequestDescription: 'The received request was deleted successfully',
          },
          communityConnectRequestPage: {
            title: 'Community connect request',
            howDoesItWorkTitle: 'How does a community connection work?',
            howDoesItWorkDescription: 'If you accept this invitation, your parking community will be connected with the inviting community. This will allow the members of the inviting community to access the parking areas and parking spots that are associated with your community\'s price and availability rules, and the members of your community will be able to access the inviting community\'s resources.',
            acceptRequest: 'Accept connect request',
            acceptedTitle: 'Request accepted',
            acceptedDescription: 'The request was accepted successfully',
            notFoundTitle: 'Request not found',
            notFoundDescription: 'The request was not found',
            communityWantsToConnect: '{{communityName}} wants to connect with your community {{communityRecipientName}}.',
            noAccessToAcceptTitle: 'No access',
            noAccessToAcceptDescription: 'You don\'t have access to accept this request',
          },
          notificationsMenu: {
            title: 'Notifications',
            noNotifications: 'No notifications',
          },
          permitQueuePage: {
            title: 'Permit queue',
            description: 'On this page, you will find a list of all the users that are currently in the queue for a permit. You can also see the number of users that are currently in the queue for a permit.',
            usersInAreaParkingQueue: 'Users in parking queue',
            usersInSpecificSpotQueue: 'Users in specific spot queue',
            addUserToQueue: 'Add User to Queue',
            areaParkingQueue: 'Parking Queue',
            enableAutomaticQueueForParkingArea: 'Enable automatic queue for parking area',
            specificSpotsQueue: 'Specific Spots Queue',
            queueSettings: 'Queue Settings',
            allowUsersToJoinParkingQueue: 'Allow users to queue for this area.',
            allowUsersToJoinSpecificSpotsQueue: 'Allow users to queue for specific parking spot.',
            allowUsersToSeeQueueCount: 'Allow users to see how many users are in the queue.',
            allowUsersToSeeQueuePosition: 'Allow users to see their position in the queue.',
            enableCommunityMembersOnly: 'Allow queue only for community members',
            leaveTheQueue: 'Leave the queue',
            joinParkingAreaQueue: 'Join area parking queue',
            joinTheQueue: 'Join the queue',
            joinQueueAndGetNotified: 'Join the queue and get notified when a parking spot is available.',
            mobileAppPreview: 'Mobile app preview',
            usersInQueueCount: '12 users in queue',
            userQueuePosition: 'Your position: Spot 3',
            reorder: 'Reorder',
            moveToTop: 'Move to top',
            moveToBottom: 'Move to bottom',
            moveToSpecificSpot: 'Move to specific spot',
            changeQueuePosition: 'Change queue position for {{name}}',
            enterPosition: 'Enter queue position (1 - {{totalItems}})',
            disclaimer: 'Disclaimer',
            disclaimerDescription: 'If you manually change order in the list, that will reflect what is displayed to the user in the app.',
            disclaimerDescriptionAutomaticQueue: 'Select the parking spots you want to enable for automatic permits – only those with a set price can be selected. To set a price, go to "Pricelist" in the left-hand menu.',
            queueSettingsSavedTitle: 'Queue settings saved successfully',
            queueSettingsSavedDescription: 'Your queue settings have been successfully saved.',
            queuePositionSavedTitle: 'Queue position saved successfully',
            queuePositionSavedDescription: 'The queue position has been successfully saved.',
            numberOfHoursToAcceptDeclinePermit: 'Number of hours to accept/decline permit',
            numberOfHoursToAcceptDeclinePermitDescription: 'Set the number of hours a user has to accept or decline a permit offer when it becomes available. If the user does not respond within the set time, the permit offer will expire and be offered to the next user in the queue.',
            cancellationPeriodInMonths: 'Cancellation period in months',
            cancellationPeriodInMonthsDescription: 'The notice period applies to all permits in this parking area. When a permit is cancelled, it stays valid until the last day of the set number of calendar months after the cancellation month. Default is 1 month.',
          },
          permitQueueTable: {
            permit: 'Permit',
            inQueueSince: 'In queue since',
            noUsersInQueue: 'No users in queue',
            specialRequests: 'Special requests',
            isRegistered: 'User Status',
            registered: 'Registered',
            notRegistered: 'Not registered',
            nobodyInQueue: 'Nobody in queue',
            issuePermit: 'Issue permit',
            deletedTitle: 'Deleted',
            deletedDescription: 'User removed from permit queue.',
            deleteQueueItemTitle: 'Remove user from permit queue',
            deleteQueueItemDescription: 'This will remove the user from the permit queue.',
            queueCantBeFetched: 'Queue can\'t be fetched',
            parkingSpot: 'Parking Spot',
            permitType: 'Permit Type',
            offerStatus: 'Offer Status',
            offerExpirationDateTime: 'Offer Expiration',
            offered: 'Offered',
            accepted: 'Accepted',
            declined: 'Declined',
            expired: 'Expired',
            cancelled: 'Cancelled',
            day: '{{count}} day',
            day_plural: '{{count}} days',
            hour: '{{count}} hour',
            hour_plural: '{{count}} hours',
            minute: '{{count}} minute',
            minute_plural: '{{count}} minutes',
            expiredAt: 'Expired at',
          },
          permitQueueItemModal: {
            titleEdit: 'Edit User in Permit Queue',
            titleAdd: 'Add User to Permit Queue',
            inputPhone: 'User Phone Number',
            userInSystem: 'User in AirPark system.',
            userNotInSystem: 'User not in the AirPark system.',
            userNotFoundMessage: 'User with phone number `{{phoneNumber}}` does not exist.',
            parkingSpot: 'Parking Spot',
            parkingArea: 'Parking Area',
            permit: 'Permit',
            inputSpecialRequests: 'Special requests',
            buttonSave: 'Save',
            permitType: 'Permit Type',
            email: 'Email',
            firstName: 'First name',
            lastName: 'Last name',
            buttonCancel: 'Cancel',
            userAlreadyInQueue: 'User already in queue.',
          },
          dashboardPage: {
            greeting: 'Hi, {{name}}!',
            createParkingAreaTitle: 'Create a parking area',
            createParkingAreaDescription: 'To get started, create a parking area. You can create multiple parking areas if you have more than one parking area. Afterwards you can create availability and price rules for your parking areas.',
            hereIsYourAirParkOverview: 'Here is your AirPark overview',
            bookingsLastTwentyFourHours: 'Bookings last 24 hours',
            activeParkingPermits: 'Active parking permits',
            totalPayouts: 'Total payouts',
            pendingPayouts: 'Pending payouts',
            revenue: 'Revenue',
            revenueDescription: 'Your revenue for the last 12 months, after AirPark fees and transaction fees have been deducted.',
            lastTwelveMonths: 'Last 12 months',
            noRevenueYet: 'No revenue yet',
          },
          statisticsPage: {
            title: 'Statistics',
            description: 'On this page you can find statistics about your parking areas.',
            revenue: 'Revenue',
            chooseParkingAreas: 'Choose parking areas',
            chooseRevenueType: 'Choose revenue type',
            total: 'Total',
            bookings: 'Bookings',
            permits: 'Permits',
            controlfees: 'Control fees',
            subletbookings: 'Sublet bookings',
            charging: 'Charging',
            chooseInterval: 'Choose interval',
          },
          payoutStatus: {
            pending: 'Pending',
            processing: 'Processing',
            processed: 'Paid',
            failed: 'Error',
            readytoprocess: 'Ready to process',
          },
          payoutTransactionType: {
            booking: 'Booking',
            permit: 'Parking permit',
            subletting: 'Subletting',
          },
          payoutsPage: {
            title: 'Payouts',
            description: 'On this page you can find a list of all your payouts. You can also see the status of each payout.',
            payouts: 'Payouts',
          },
          payoutsTable: {
            payoutDate: 'Payout date',
            noPayoutsFound: 'No payouts found',
            description: 'Description',
            period: 'For Period'
          },
          payoutDetailsPage: {
            title: 'Payout details',
            description: 'On this page you\'ll find the details for your payout with ID {{payoutExtId}}.',
            sum: 'Sum',
            payoutDate: 'Payout date',
            vat: 'VAT',
            status: 'Status',
            payoutLines: 'Payout lines',
            exportToCsv: 'Export to CSV',
            printSummary: 'Print summary',
            openCsvTitle: 'Open CSV',
            openCsvDescription: 'To open the CSV file, you need a program that can read CSV files, such as Excel or Numbers. In Numbers, you don\'t need to do anything special to open the file. In Excel, you need to select column A, then click on "Data" in the menu, choose "Text to Columns," select "Delimited," check the "Comma" option, and then click "OK."',
          },
          payoutDetailsTable: {
            type: 'Type',
            sum: 'Sum',
            amount: 'Amount',
            vat: 'VAT',
            transactionFee: 'Transaction fee',
            airParkFee: 'AirPark fee',
            propertyOwnerFee: 'Property owner fee',
            subletting: 'Subletting',
            paymentProvider: 'Payment provider',
            paymentAmount: 'Payment amount',
            totalVat: 'Total VAT',
            ownerAmount: 'Owner amount',
            subletterAmount: 'Subletter amount',
            payoutAmount: 'Payout amount',
            vatOnPayoutAmount: 'VAT on payout amount',
            paymentExtId: 'Payment ID',
          },
          controlFeesPage: {
            title: 'Control fees',
            description: 'On this page you can find a list of all your control fees. You can also see the status of each control fee.',
            videoInstructionsDescription: 'Watch our video instructions on how to issue control fees.',
            signsRequiredTitle: 'Valid signs required',
            signsRequiredDescription: 'You need to have valid signs – that meet the legal requirements – at the entrance to your parking area that informs the users that they are entering a controlled parking area. Contact AirPark if you are unsure or need to order these.',
            contactAirPark: 'Contact AirPark',
          },
          controlFeesTable: {
            createdAt: 'Reported date',
            status: 'Status',
            amount: 'Amount',
            noControlFeesFound: 'No control fees found',
            pending: 'In review by AirPark',
            approved: 'Approved by AirPark',
            rejected: 'Rejected by AirPark',
            paid: 'Paid',
            overdue: 'Overdue',
            paymentDue: 'Payment due',
            unspecified: 'Unspecified',
            wrongSpot: 'Wrong spot',
            overstayed: 'Overstayed',
            forbidden: 'Parking forbidden',
            outsideMarks: 'Outside parking marks',
            paymentDueDate: 'Payment due date',
            reason: 'Reason for control fee',
            unpaid: 'Unpaid',
            paymentStatus: 'Payment status',
            notes: 'Notes',
          },
          permitParkingSpotsPage: {
            title: 'Parking spots with permits',
            description: 'On this page you can find a list of all the parking spots that have permits.',
          },
          permitParkingSpotsTable: {
            permits: 'Permits',
            permit: 'permit',
            marketplacePermits: 'permits in marketplace',
            id: 'Id',
            objectId: 'ObjectID',
            locationSpecific: 'Specific location',
            floor: 'Floor',
            number: 'Number',
            features: 'Features',
            automatic: 'Automatic permit',
          },
          permitsModal: {
            id: 'Id',
            spotIdentifier: 'Spot',
            name: 'Name',
            notes: 'Notes',
            permits: 'Permits'
          },
          controlFeesSettingsPage: {
            title: 'Control fees settings',
            description: 'On this page you can manage the settings for control fees.',
            whoIsAllowedToIssueControlFees: 'Who is allowed to issue control fees?',
            noone: 'No one',
            communityMembers: 'Community members',
            everyone: 'Everyone',
            controlFeeAmount: 'Control fees amount',
            controlFeeSettingsUpdatedTitle: 'Updated',
            controlFeeSettingsUpdatedDescription: 'Control fee settings updated',
          },
          signsPage: {
            title: 'Signs',
            description: 'Make it easy for your parking customers to find their spot. On this page you can download signs for your parking area and print them.',
            alertTitle: 'Other signs',
            alertDescription: 'If you need official road signs to be able to issue control fees or require other signs, please contact'
          },
          parkingAreaSignsPdf: {
            getTheApp: 'Get the app',
            parkingArea: 'Parking area',
            area: 'Area'
          },
          payoutPrintPage: {
            title: 'Payout summary',
            subletting: 'Subletting',
            sublettingVat: 'Subletting, VAT',
            bookings: 'Bookings',
            bookingsVat: 'Bookings, VAT',
            permits: 'Permits',
            permitsVat: 'Permits, VAT',
            controlFees: 'Control fees',
            controlFeesVat: 'Control fees, VAT',
            totalExVat: 'Total, excl. VAT',
            total: 'Total',
            totalVat: 'Total, VAT',
            period: 'Period',
            reference: 'Our reference',
            address: 'Address',
            vatNumber: 'VAT number',
            organizationNumber: 'Org. number',
            payoutReference: 'Payout reference',
            payoutDate: 'Payout date',
            charging: 'Charging',
            chargingVat: 'Charging, VAT',
          },
          chargingPage: {
            title: 'Electric car charging',
            description: 'On this page you can configure charging for your parking spaces.',
            pricingTitle: 'Price for electric car charging',
            pricingDescription: 'Here you can configure prices for charging in your parking spaces.',
            addChargingStationTitle: 'Add electric car charger',
            addChargingStationDescription: 'Here you can add electric car chargers to your parking spaces.',
            priceForCharging: 'Price',
            priceForChargingTooltip: 'The price to be paid to charge the electric car.',
          },
          chargingStationPage: {
            addTitle: 'Add charging station',
            selectParkingSpot: 'Select parking spot',
            selectProvider: 'Select provider',
            selectParkingSpotWarning: 'Please select a parking spot where the charging station will be located.',
            selectedParkingSpot: '{{spot}} is selected',
            addSuccessTitle: 'Charging station added',
            addSuccessDescription: 'Charging station added successfully.',
            editTitle: 'Edit charging station',
            updatedSuccessTitle: 'Charging station updated',
            updatedSuccessDescription: 'Charging station updated successfully.',
          }, 
          waybler: {
            chargingStationId: 'Waybler charging station ID',
            chargingStationIdPlaceholder: 'Enter Waybler charging station ID',
          },
          chargingStationsTable: {
            id: 'Id',
            parkingSpotFloor: 'Parking spot floor',
            parkingSpotNumber: 'Parking spot number',
            chargingProvider: 'Charging provider',
            noChargingStationsFound: 'No charging stations found',
            chargingProviderExternalId: 'Charging provider external ID',
            removeChargingStationTitle: 'Remove charging station',
            removeChargingStationDescription: 'Are you sure you want to remove the charging station?',
            removedChargingStationTitle: 'Charging station removed',
            removedChargingStationDescription: 'Charging station removed successfully.',
            noChargingStations: 'No charging stations',
            charging: 'Charging',
            notCharging: 'Not charging',
            status: 'Status'
          },
          airPassPage: {
            title: 'AirPass',
            description: 'On this page you can find a list of all your AirPasses.',
          },
          airPassTable: {
            id: 'Id',
            description: 'Description',
            location: 'Location',
            noAirPassesFound: 'No AirPasses found',
            floor: 'Floor',
            openPassage: 'Open passage',
            openPassageConfirmTitle: 'Are you sure?',
            openPassageConfirmDescription: 'By confirming, you will send a request to open the passage "{{description}}" ({{id}}).',
            openPassageSuccessTitle: 'Success',
            openPassageSuccessDescription: 'Passage opened successfully.',
            openPassageErrorTitle: 'Error',
            openPassageErrorDescription: 'Failed to open passage.',
          },
          editAirPassPage: {
            title: 'Edit AirPass',
            airPassDescriptionTitle: 'Description',
            airPassDescriptionPlaceholder: 'Enter AirPass description',
            editAirPassPosition: 'Edit AirPass position',
            updatedSuccessTitle: 'Updated',
            updatedSuccessDescription: 'AirPass updated successfully.',
          },
          customAgreementPage: {
            title: 'Custom agreement',
            description: 'On this page you can upload a custom agreement that will need to be accepted by the user when they sign up for a permit.',
            customAgreement: 'Custom agreement',
          },
          parkingSpotsPricePage: {
            title: 'Pricelist',
            description: 'View parking spots and edit price per spot',
            price: 'Price',
            savedDesc: 'Saved',
            savedTitle: 'Price updated successfully',
            editPriceTitle: 'Edit parking spot price',
            spotId: 'Parking spot ID',
            bulkEditPrice: 'Bulk edit parking spot prices',
          },
          bookingsPage: {
            title: 'Bookings',
            description: 'On this page you can find a list of all your bookings for your parking area.',
            parkingSpot: 'Parking spot',
            startDate: 'Start date',
            endDate: 'End date',
            duration: 'Duration',
            paidAmount: 'Paid amount',
            registrationIdentifier: 'Registration identifier',
            expired: 'Expired',
            noResult: 'No bookings found',
          },
          acceptTermsAndConditionsPage: {
            title: 'Accept terms and conditions',
            description: 'To continue using AirPark, you need to accept the updated terms and conditions.',
            accept: 'Accept',
            privacyPolicy: 'Privacy policy',
            termsAndConditions: 'Terms and conditions',
          }
        }
      },

      /* SWEDISH */
      sv: {
        translation: {
          generic: {
            successTitle: 'Uppdaterat',
            successDescription: 'Uppdateringen lyckades',
            errorTitle: 'Något gick fel',
            errorDescription: 'Något gick fel, vänligen försök igen.',
            missingKeyReplacement: '...',
            yes: 'Ja',
            no: 'Nej',
            remove: 'Ta bort',
            close: 'Stäng',
            back: 'Tillbaka',
            edit: 'Redigera',
            cancel: 'Avbryt',
            ok: 'OK',
            save: 'Spara',
            update: 'Uppdatera',
            email: 'E-post',
            phone: 'Telefonnummer',
            search: 'Sök',
            airPark: 'AirPark',
            create: 'Skapa',
            missingFieldsTitle: 'Fält saknas',
            missingFieldsDescription: 'Ett eller flera fält saknar information eller är inte korrekt ifyllda',
            saving: 'Sparar',
            uploadImageFiles: "Klicka för att ladda upp bilder eller dra och släpp PNG, JPG, JPEG eller GIF",
            uploadDocumentFiles: "Klicka för att ladda upp filer eller dra och släpp GIF, JPG, JPEG PDF, eller PNG",
            warning: "Varning",
            areyousure: "Är du säker?",
            share: 'Dela',
            add: 'Lägg till',
            invite: 'Bjud in',
            signin: 'Logga in',
            signup: 'Registrera',
            signout: 'Logga ut',
            create: 'Skapa',
            status: 'Status',
            firstName: 'Förnamn',
            lastName: 'Efternamn',
            from: 'Från',
            to: 'Till',
            id: 'Id',
            amount: 'Summa',
            status: 'Status',
            choose: 'Välj',
            change: 'Ändra',
            revoke: 'Avsluta',
            videoInstructions: 'Videoinstruktioner',
            updated: 'Uppdaterat',
            updatedDescription: 'Uppdateratingen lyckades',
            download: 'Ladda ner',
            day: 'Dag',
            month: 'Månad',
            pending: 'Pågående',
            copy: 'Kopiera',
            copied: 'Kopierat',
            copiedDescription: 'Kopierat till urklipp',
            price: 'Pris',
            unit: 'Enhet',
            termsAndConditionsUrl: 'https://static.airpark.app/policy/2023/terms_and_conditions_sv-se.pdf',
            upload: 'Ladda upp',
            all: 'Alla',
            selected: 'Vald'
          },
          validation: {
            invalidPhoneNumber: 'Ogiltigt telefonnummer',
            requiredField: 'Obligatoriskt fält',
            invalidPrice: 'Ogiltigt pris',
          },
          error: {
            userAlreadyHaveAnIndividualOrganizationTitle: 'Du har redan en enskild organisation',
            userAlreadyHaveAnIndividualOrganizationDescription: 'Du kan inte ha flera enskilda organisationer',
            priceRuleSetRecurringTimeEqualTitle: 'Återkommande tid kan inte vara 24 timmar',
            priceRuleSetRecurringTimeEqualDescription: 'Tid Från och Tid Till kan inte vara lika. Justera tidsintervallet.',
          },
          legend: {
            totalAmount: 'Totala intäkter',
            bookingsAmount: 'Bokningar',
            permitsAmount: 'Parkeringstillstånd',
            controlFeesAmount: 'Kontrollavgifter',
            revenue: 'Intäkter',
          },
          dayShortNames: {
            monday: 'Må',
            tuesday: 'Ti',
            wednesday: 'On',
            thursday: 'To',
            friday: 'Fr',
            saturday: 'Lö',
            sunday: 'Sö'
          },
          daySingularNames: {
            monday: 'Måndag',
            tuesday: 'Tisdag',
            wednesday: 'Onsdag',
            thursday: 'Torsdag',
            friday: 'Fredag',
            saturday: 'Lördag',
            sunday: 'Söndag'
          },
          dayPluralNames: {
            monday: 'Måndagar',
            tuesday: 'Tisdagar',
            wednesday: 'Onsdagar',
            thursday: 'Torsdagar',
            friday: 'Fredagar',
            saturday: 'Lördagar',
            sunday: 'Söndagar'
          },
          navigation: {
            'parking-areas': 'Områden',
            'permits': 'Tillstånd',
            'queue': 'Kö',
            'community': 'Community',
            'control-fees': 'Kontrollavgifter',
            'marketplace': 'Marketplace',
            'parking-spots': 'Parkeringsplatser',
            'settings': 'Inställningar',
            'users': 'Användare',
            'connect-requests': 'Förfrågningar',
            'reports': 'Rapporter',
            'payouts': 'Utbetalningar',
            'revenue': 'Intäkter',
            'revenue-sharing': 'Intäktsdelning',
            'occupancy': 'Beläggning',
            'payout': 'Utbetalning',
            'signs': 'Skyltmaterial',
            'statistics': 'Statistik',
            'custom-agreement': 'Anpassat avtal',
            'bookings': 'Bokningar',
            'connections': 'Sammanlänkade communities',
            'charging': 'Elbilsladdning',
            'airpass': 'AirPass',
            'contract-codes': 'Kontraktskoder',
          },
          paging: {
            pageOfTotal: 'Sida {{page}} av {{total}}'
          },
          priceUnit: {
            hour: 'h',
            day: 'dag',
            month: 'mån',
            year: 'år',
            onetime: 'engång'
          },
          defaultLayout: {
            loading: 'Laddar...'
          },
          loginPage: {
            byLoggingInYouApprove: "Genom att logga in godkänner du",
            conditions: "villkoren",
            rememberMe: "Kom ihåg mig",
            mobileNumber: "Mobilnummer",
            selectCountryCode: "Välj land/region",
            search: "sök",
            loginWithMobileNumber: 'Logga in med mobilnummer',
            loginWithEmail: 'Logga in med e-post',
            emailIsNotValid: 'E-postadressen är inte giltig',
            noAccountSignup: 'Inget konto? Registrera dig',
            useTheApp: 'Visste du att du superenkelt kan hyra ut din parkeringsplats direkt i vår app? Ladda ner den här.',
          },
          verifySmsCodePage: {
            verifyCode: "Mata in kod",
            enterTheCodeThatWasSentTo: "Mata in koden som skickades till",
            didNotReceiveCode: "Fick du ingen kod? Försök igen",
            newCodeSentTitle: "Ny kod skickad",
            newCodeSentDescription: "En ny kod har skickats till telefonnummer",
            codeCouldNotBeVerifiedTitle: "Kod ej giltig",
            codeCouldNotBeVerifiedDescription: "Koden kunde inte verifieras. Försök igen."
          },
          registerPage: {
            beforeWeGetStarted: "Innan vi kör igång",
            description: "För att ta del av tjänsten och ge dig en fantastisk service behöver vi lite mer information om dig.",
            firstName: "Förnamn",
            surName: "Efternamn",
            country: 'Land',
            accept: 'Jag accepterar AirParks',
            termsAndConditions: 'allmänna villkor',
          },
          chooseOrganizationPage: {
            chooseOrganization: "Välj organisation",
            description: "Tillgängliga organisationer som du kan administrera parkeringar för.",
            createNewOrganization: "Skapa ny organisation",
            noOrganizationAvailableTitle: "Ingen organisation tillgänglig",
            noOrganizationAvailableDescription: "Ingen organisation tillgänglig. Skapa en ny organisation för att organisera dina parkeringar."
          },
          createOrganizationPage: {
            createOrganization: "Skapa organisation",
            description: "Skapa en organisation för att samla dina parkeringar. Det kan exempelvis vara ditt eget namn, namnet på din bostadsrättsförening eller företag.",
            nameMissingTitle: 'Namn saknas',
            nameMissingDescription: 'Fyll i all information för att skapa en organisation.',
            typeOfOrganization: 'Företag eller privatperson?',
            typeOfOrganizationTooltip: 'Ange vilken organisationstyp som du registrerar dig som. Är din organisation något annat än privatperson väljer du företag.',
            company: 'Företag',
            individual: 'Privatperson',
            country: 'Land',
            name: 'Namn',
            orgNbr: 'Organisationsnummer',
            socialSecurityNumber: 'Personnummer',
            address: 'Adress',
            zipCode: 'Postnummer',
            city: 'Stad',
            phone: 'Telefonnummer',
            email: 'E-post',
            youMustAcceptTermsAndConditionsTitle: 'Villkor ej accepterade',
            youMustAcceptTermsAndConditionsDescription: 'Du måste acceptera villkoren för att kunna skapa en organisation.',
            missingRequiredInfoTitle: 'Obligatorisk information saknas',
            missingRequiredInfoDescription: 'Du måste fylla i all nödvändig information.',
          },
          leftMenu: {
            start: "Start",
            areas: "Områden",
            reports: "Rapporter",
            users: "Användare",
            settings: "Inställningar",
            payouts: 'Utbetalningar',
            occupancy: 'Beläggning',
            revenue: 'Intäkter',
            payoutSettings: 'Utbetalningskonto',
            revenueSharing: 'Intäktsdelning',
            statistics: 'Statistik',
          },
          leftMenuParkingArea: {
            parking: "Parkering",
            permits: "Tillstånd",
            queue: "Kö",
            controlfees: "Kontrollavgifter",
            community: "Community",
            parkingSpots: "Parkeringsplatser",
            marketplace: "Marketplace",
            linkedCommunities: 'Länkade communities',
            controlFeesSettings: 'Inställningar',
            signs: 'Skyltmaterial',
            charging: 'Elbilsladdning',
            airPass: 'AirPass',
            customAgreement: 'Anpassat avtal',
            bookings: 'Bokningar',
            parkingSpotsPrice: 'Prislista',
            contractCodes: 'Kontraktskoder',
            discountCodes: 'Rabattkoder',
            objectIds: 'Objekt-id',
            assignment: 'Tilldelning'
          },
          assignment: {
            title: 'Mass-tilldelning av tillstånd',
            subtitle: 'Massuppdatering av tillstånd via Excel-fil.',
            description: 'Ladda ner Excel-mallen (förifylld med platser som har Objekt-id), fyll i telefonnummer, regnummer och datum, och ladda upp. Grå kolumner är låsta — endast vita kolumner får ändras.',
            step1Title: 'Förstå format',
            step2Title: 'Välj fil',
            step3Title: 'Förhandsgranska',
            step4Title: 'Klart',
            uploadStepTitle: 'Ladda upp Excel-fil',
            uploadStepDescription: 'Välj den ifyllda mallen eller importera direkt från ditt fastighetssystem.',
            previewStepTitle: 'Förhandsgranska tilldelningar',
            clientErrors: 'Fel i filen',
            clientWarnings: 'Varningar',
            continue: 'Fortsätt',
            back: 'Tillbaka',
            startOver: 'Börja om',
            confirmReset: 'Kasta laddad fil och börja om?',
            rerunDryRun: 'Kontrollera igen',
            uploadAnother: 'Ladda upp en till',
            rowTableHelp: 'Tabellen visar alla rader. Klassificering visas till höger — fixa felaktiga rader i Excel och ladda upp filen igen.',
            tableHelp: 'Klicka på en cell för att redigera direkt.',
            editedRowsLabel: 'Ändrade rader: {{count}}. Klicka "Kontrollera mot systemet" för att verifiera.',
            editedTooltip: 'Ändrad i portalen',
            clickToEdit: 'Klicka för att redigera',
            downloadEdited: 'Ladda ner uppdaterad mall',
            colRow: 'Rad',
            colSpotIdentifier: 'Platsnummer',
            colKind: 'Klassificering',
            kindIgnored: 'Hoppas över',
            kindDormant: 'Vilande user',
            kindActivate: 'Tillstånd',
            kindError: 'Fel',
            howItWorksTitle: 'Så här bearbetas filen',
            howItWorks_create: 'Ledig plats + nytt telefonnummer → nytt tillstånd skapas (samt vilande användare om numret inte finns).',
            howItWorks_create_label: 'Nytt tillstånd',
            howItWorks_update: 'Befintligt tillstånd för samma person på samma plats + nytt slutdatum → slutdatum uppdateras.',
            howItWorks_update_label: 'Slutdatum uppdateras',
            howItWorks_transition: 'Två rader på samma plats — en avslutar ett befintligt tillstånd, nästa startar nytt (t.ex. Kalle slutar 2026-05-31 → Lisa börjar 2026-06-01).',
            howItWorks_transition_label: 'Övergång',
            howItWorks_dormant: 'Bara telefonnummer (inga datum) → endast vilande användare skapas, inget tillstånd.',
            howItWorks_dormant_label: 'Vilande användare',
            howItWorks_noChange: 'Samma data som redan finns → inget händer.',
            howItWorks_noChange_label: 'Ingen ändring',
            howItWorks_ignored: 'Tomt telefonnummer → raden ignoreras.',
            howItWorks_ignored_label: 'Tom rad ignoreras',
            howItWorks_phoneFormat: 'Telefonnummer normaliseras automatiskt — både 0701234567 och +46701234567 fungerar och matchar samma användare.',
            howItWorks_phoneFormat_label: 'Telefonformat',
            duplicateRowError: 'Rader {{rows}} har samma Objekt-id "{{objectId}}" + Telefonnummer "{{phone}}" — endast unika kombinationer tillåts inom uppladdningen. Rätta filen och försök igen.',
            unknownExtIdError: 'Plats-ID finns inte i området ({{details}}). Plats-ID-kolumnen får inte ändras — ladda ner mallen igen och fyll i de vita kolumnerna.',
            downloadTemplate: 'Ladda ner mall',
            uploadExcel: 'Ladda upp Excel',
            dryRun: 'Kontrollera mot systemet',
            execute: 'Utfärda tillstånd',
            confirmExecute: 'Detta skapar tillstånd och vilande användare. Fortsätta?',
            rowsLoaded: 'Rader inlästa',
            dryRunResult: 'Förhandsgranskning',
            executeResult: 'Utfärdande-resultat',
            blockingErrors: 'Fel som blockerar körning',
            blockedByErrors: 'Körning blockerad av fel',
            totalRows: 'Totalt rader',
            newPermits: 'Nya tillstånd',
            updatedPermits: 'Uppdaterade tillstånd',
            transitions: 'Övergångar',
            dormantUsers: 'Vilande användare',
            noChange: 'Ingen ändring',
            ignored: 'Ignorerade',
            rowIndex: 'Rad',
            phone: 'Telefon',
            action: 'Åtgärd',
            message: 'Meddelande',
            colAction: 'Vad händer',
            colPrice: 'Pris',
            colSublet: 'Andrahand',
            colThirdParty: 'Annan part',
            colSpot: 'Plats',
            colObjectId: 'Objekt-id',
            colPhone: 'Telefon',
            colReg: 'Regnummer',
            colFromDate: 'Från',
            colToDate: 'Till',
            colExplanation: 'Förklaring',
            permitsCreated: 'tillstånd skapade',
            loadFailed: 'Kunde inte ladda parkeringsplatser',
            parseFailed: 'Kunde inte parsa Excel-filen',
            dryRunFailed: 'Förhandsgranskning misslyckades',
            executeFailed: 'Utfärdande misslyckades',
            importFromExternal: 'Importera från fastighetssystem',
            importedFromExternal: 'Importerade {{count}} rader från fastighetssystem'
          },
          assignmentImport: {
            title: 'Importera från fastighetssystem',
            description: 'Ladda upp en fil i ditt fastighetssystems format (Yardi, Re! m.fl.). Mappa sedan varje AirPark-fält till motsvarande kolumn.',
            emptyFile: 'Filen innehåller inga rader.',
            parseFailed: 'Kunde inte parsa filen. Kontrollera att det är en giltig Excel-fil.',
            rawDataPreview: 'Förhandsgranskning av rådata ({{count}} rader totalt)',
            columnMapping: 'Kolumn-mappning (AirPark-fält → Excel-kolumn)',
            convertedPreview: 'Förhandsgranskning efter mappning (5 första raderna)',
            notMapped: '— ej mappad —',
            missingFields: 'Saknade obligatoriska fält: {{fields}}',
            useMapping: 'Använd mappningen'
          },
          objectIds: {
            title: 'Objekt-id per parkeringsplats',
            description: 'Ladda ner Excel-filen, redigera Platsnummer- eller Objekt-id-kolumnen och ladda upp igen för massuppdatering. Plats-ID-kolumnen är låst (intern nyckel).',
            download: 'Ladda ner Excel',
            upload: 'Ladda upp Excel',
            uploading: 'Laddar upp...',
            spotIdentifier: 'Platsnummer',
            objectId: 'Objekt-id',
            loadFailed: 'Kunde inte ladda parkeringsplatser',
            uploadFailed: 'Kunde inte uppdatera Objekt-id',
            updated: 'Uppdaterat',
            unknownSpotIds: 'Okända Plats-ID',
            duplicateInFile: 'Duplicerat Objekt-id i filen',
            unnumbered: 'Ej numrerad',
            id: 'Plats-ID',
            searchPlaceholder: 'Sök på Plats-ID, Platsnummer eller Objekt-id',
            noResults: 'Inga träffar',
            pageOf: 'Sida {{page}} av {{total}}',
            previewLoading: 'Räknar ut förhandsgranskning…',
            previewFailed: 'Kunde inte generera förhandsgranskning',
            previewTitle: 'Förhandsgranskning — vad kommer hända?',
            confirmUpload: 'Bekräfta uppladdning',
            xlsxParseError: 'Filen kunde inte läsas. Kontrollera att det är en giltig Excel-fil.',
            noRowsFound: 'Inga giltiga rader hittades i filen (kolumn "Plats-ID" krävs).',
            previewSummary: '{{total}} rader analyserade — {{changes}} ger ändringar.',
            previewSummarySet: '{{count}} platser får nytt objekt-id (var tomt).',
            previewSummaryChange: '{{count}} platser får sitt objekt-id ändrat.',
            previewSummaryClear: '{{count}} platser får sitt objekt-id borttaget.',
            previewSummaryRename: '{{count}} numrerade platser får nytt Platsnummer.',
            previewSummarySetAndRename: '{{count}} platser får BÅDE Objekt-id och Platsnummer ändrat.',
            previewSummaryNoChange: '{{count}} rader ger ingen ändring.',
            previewSummarySkipUnknown: '{{count}} Plats-ID finns inte i området — hoppas över.',
            previewSummaryDupObj: '{{count}} objekt-id-dubbletter inom filen — hoppas över.',
            previewSummaryDupSpot: '{{count}} dubbletter av Platsnummer inom filen — hoppas över.',
            previewSummarySkipUnnumbered: '{{count}} ej-numrerade platser kan inte döpas om (endast objekt-id uppdateras).',
            previewSummaryErrors: '{{count}} rader har fel.',
            previewColAction: 'Action',
            previewColExplanation: 'Vad som händer',
            actionSet: 'Sätt objekt-id',
            actionChange: 'Ändra objekt-id',
            actionClear: 'Ta bort objekt-id',
            actionRename: 'Döp om plats',
            actionClearSpot: 'Ta bort platsnummer',
            actionSetAndRename: 'Sätt + döp om',
            actionNoChange: 'Ingen ändring',
            actionSkipUnknown: 'Hoppas över — okänd plats',
            actionSkipDupObj: 'Hoppas över — dubblett objekt-id',
            actionSkipDupSpot: 'Hoppas över — dubblett platsnamn',
            actionSkipUnnumbered: 'Kan inte döpa om ej-numrerad',
            actionError: 'Fel',
            kpiTotal: 'Totalt',
            kpiChanges: 'Ändringar',
            kpiNoChange: 'Oförändrade',
            kpiIssues: 'Att åtgärda',
            filterLabel: 'Visa:',
            filterAll: 'Alla',
            filterChanges: 'Ändringar',
            filterNoChange: 'Oförändrade',
            filterIssues: 'Att åtgärda',
            filterNoResults: 'Inga rader matchar valt filter.',
          },
          discountCodes: {
            title: 'Rabattkoder',
            searchPlaceholder: 'Sök på kod eller kampanj',
            createButton: 'Skapa rabattkod',
            createTitle: 'Skapa ny rabattkod',
            editTitle: 'Redigera rabattkod',
            tabActive: 'Aktiva',
            tabInactive: 'Inaktiva',
            tabDeleted: 'Borttagna',
            code: 'Kod',
            campaignName: 'Kampanjnamn',
            percent: 'Rabatt (%)',
            maxHours: 'Maxtid per tillfälle (timmar)',
            maxHoursLabel: 'Max parkeringstid per tillfälle i timmar',
            unlimitedHint: '0 eller tomt = obegränsat',
            maxUsages: 'Max antal användningar',
            validFrom: 'Giltig från',
            validUntil: 'Giltig till',
            status: 'Status',
            usages: 'Användningar',
            actions: 'Åtgärder',
            save: 'Spara',
            edit: 'Redigera',
            deactivate: 'Inaktivera',
            reactivate: 'Aktivera',
            delete: 'Ta bort',
            restore: 'Återställ',
            deleteConfirm: 'Är du säker på att du vill ta bort "{{code}}"?',
            deletedAt: 'Borttagen',
            totalDiscounted: 'Total rabatt',
            usageLog: 'Användningslogg',
            date: 'Datum',
            bookingId: 'Boknings-id',
            originalAmount: 'Ursprung',
            discounted: 'Rabatt',
            final: 'Slutpris',
            stats: 'Statistik',
            monthlyBreakdown: 'Senaste månaderna',
            month: 'Månad',
            noUsagesYet: 'Inte använd än',
            viewBookings: 'Visa bokningar med rabattkoden',
            discountCodeColumn: 'Rabattkod',
            createdAt: 'Skapad',
            status_Active: 'Aktiv',
            status_Expired: 'Utgången',
            status_FullyUsed: 'Fullt använd',
            status_NotStarted: 'Ej startad',
            status_Inactive: 'Inaktiv',
            status_Deleted: 'Borttagen',
            codeRequired: 'Kod är obligatoriskt',
            invalidPercent: 'Procent måste vara mellan 1 och 100',
            errCodeRequired: 'Kod är obligatoriskt',
            errCodeFormat: 'Kod får bara innehålla A–Z, 0–9, _ och - (max 32 tecken)',
            errCampaignTooLong: 'Kampanjnamn får vara max 100 tecken',
            errPercentRequired: 'Rabatt-procent är obligatoriskt',
            errPercentInteger: 'Rabatt-procent måste vara ett heltal',
            errUsagesInvalid: 'Max antal användningar måste vara 0 eller större (0 = obegränsat)',
            errHoursInvalid: 'Max parkeringstid måste vara 0 eller större (0 = obegränsat)',
            errUntilBeforeFrom: 'Giltig till måste vara senare än Giltig från',
            loadFailed: 'Kunde inte ladda rabattkoder',
            loadUsagesFailed: 'Kunde inte ladda användningar',
            created: 'Rabattkod skapad',
            createFailed: 'Kunde inte skapa rabattkod',
            updated: 'Rabattkod uppdaterad',
            updateFailed: 'Kunde inte uppdatera rabattkod',
            deactivated: 'Rabattkod inaktiverad',
            reactivated: 'Rabattkod aktiverad',
            deleted: 'Rabattkod borttagen',
            deleteFailed: 'Kunde inte ta bort rabattkod',
            restored: 'Rabattkod återställd',
            restoreFailed: 'Kunde inte återställa rabattkod'
          },
          getStartedWidgets: {
            welcome: "Välkommen till AirPark!",
            hello: "Hej {{name}}!",
            intro: "Detta är din startsida, efterhand som du aktiverar och hyr ut parkeringar kommer vi kunna mäta och ge dig intressant data här.",
            letsgo: "Nu kör vi!",
            createParkingAreasTitle: "Parkeringsområden",
            createParkingAreasDescription: "Sätt upp område där du kan lägga till en eller flera parkeringsplatser.",
            addBasicInformationTitle: "Grundinformation",
            addBasicInformationDescription: "Lägg upp information som exempelvis pris för parkeringen, beskrivning, bild, m.m.",
            addPriceRulesAndRewardTitle: "Prisregler och rewards",
            addPriceRulesAndRewardDescription: "Lägg in prisregler för att boosta dina inäkter. Du kan även skapa rewards för att belöna dina kunder när de parkerar!",
            toParkingAreas: 'Gå till parkeringsområden'
          },
          parkingAreas: {
            noAreasTitle: "Inga områden tillagda",
            noAreasDescription: "Börja med att lägg till ett område som innehåller en eller flera parkeringar.",
            areas: "Områden",
            addArea: "Lägg till område",
            pin: "Fäst",
            name: "Namn",
            parkings: "Parkeringar",
            noParkingAreas: "Inga parkeringsområden",
            videoInstructionsDescription: "Här kan du se en videoinstruktion om hur du lägger till ett parkeringsområde.",
          },
          topBar: {
            organizations: "Organisationer",
            addOrganization: 'Skapa ny organisation',
            logout: 'Logga ut'
          },
          createParkingArea: {
            name: "Namn",
            basics: "Områdesinformation",
            hour: "timme",
            day: "dag",
            oneTimeFee: "engångsavgift",
            position: "Position",
            basePrice: "Baspris",
            positionDescription: "Sök upp ditt område på kartan där parkeringsområdet är. Klicka sedan ut punkter på kartan för att ange ett område.",
            removePosition: "Ta bort område",
            detailsHeader: "Antal platser och features ",
            detailsDescription: "Uppge hur många platser som finns inomhus respektive utomhus samt vilka features det finns.",
            indoors: "Inomhus",
            outdoors: "Utomhus",
            chargingPost: "Laddbox",
            fenced: "Inhägnat", 
            locationSpecific: "Platsspecifik",
            heaterCharging: "Motorvärmare",
            disabilityParking: "PRH",
            caravan: "Ställplats",
            mobileHome: "Garage",
            information: "Information",
            photo: "Foton",
            totalNumberOfParkingSpots: "Totalt {{totalNumberOfParkingSpots}} parkeringsplatser",
            confirm: 'Bekräfta parkeringsområdet',
            confirmDescription: 'Vi behöver dokumentation som styrker att du har rätt att lägga upp parkeringsområdet. Ladda upp dokument där AirPark kan verifiera detta. AirPark kontrollerar och återkommer.',
            address: 'Adress',
            noAddress: 'Ange ett område på kartan först genom att klicka ut punkter',
            changeAddress: 'Inte rätt adress? Skriv in adressen manuellt',
            city: 'Stad',
            zipCode: 'Postnummer',
            country: 'Land',
            search: 'Sök...',
            notnumbered: 'Ej numrerade',
            numbered: 'Numrerade',
            add: 'Lägg till',
            numberedTitle: 'Är parkeringsplatserna numrerade?',
            features: 'Egenskaper',
            from: 'Från',
            to: 'Till',
            parkingSpots: 'Parkeringsplatser',
            addParkingSpots: 'Lägg till parkeringsplatser',
            parkingAreaDetailsTitle: 'Beskrivning',
            parkingAreaDetailsDescription: 'Om det finns specifik information om parkeringsområdet eller bild så ange det här.',
            creatingParkingArea: 'Lägger upp...',
            inReviewTitle: '{{name}} inskickat för godkännande',
            inReviewDescription: 'AirPark kommer nu att titta på inskickad dokumentation och ditt parkeringsområde. Under tiden kan du göra fler inställningar såsom att sätta upp prisregler och ställa in för vem parkeringsområdet är tillgängligt för.',
            successTitle: '{{name}} upplagt',
            successDescription: 'I nästa läge kan du göra fler inställningar såsom att sätta upp prisregler och ställa in för vem parkeringsområdet är tillgängligt för.',
            amount: 'Antal',
            somethingWentWrongTitle: 'Något gick fel',
            somethingWentWrongDescription: 'Något gick fel när parkeringsområdet skulle skapas. Vänligen försök igen. Kontakta AirPark support om problemet kvarstår.',
            fileNotValidTitle: 'Fil ej giltig',
            fileNotValidDescription: 'Filen är inte giltig. Vänligen använd en PNG, JPG, JPEG eller GIF med en storlek på max 10MB.',
            floor: "Plan"
          },
          parkingAreaMap: {
            removeArea: 'Ta bort område'
          },
          parkingArea: {
            edit: 'Redigera',
            description: 'Beskrivning',
            noDescription: 'Ingen beskrivning för {{name}}',
            free: 'gratis',
            add: 'Lägg till',
            yes: 'Ja',
            no: 'Nej',
            downloadSigns: 'Ladda ner skyltar',
            notNumbered: 'Ej numrerad',
            features: 'Egenskaper',
            locationSpecific: 'Platsspecifik',
            floor: 'Plan',
            unspecified: 'Ej angivet',
            indoors: 'Inomhus',
            outdoors: 'Utomhus',
            fenced: 'Inhägnat',
            hasChargingPost: 'Laddbox',
            caravan: 'Ställplats',
            mobileHome: 'Garage',
            heaterCharging: 'Motorvärmare',
            disabilityParking: 'PRH',
            parkingSpotsType: 'Typ av parkeringsplatser',
            id: 'Id',
            objectId: 'Objekt-id',
            number: 'Nummer',
            parkings: 'Parkeringsplatser',
            awaitingApprovalTitle: '{{name}} granskas',
            awaitingApprovalDescription: '{{name}} granskas just nu av AirPark och väntar på godkännande. Under tiden kan du fylla på med parkeringar, prisregler osv. Området kommer inte dyka upp i appen förrän AirPark godkänt inskickat underlag.',
            availability: 'Pris & Tillgänglighet',
            outsideAvailabilityHours: 'Övrig tid',
            updatedTitle: 'Uppdaterat',
            updatedDescription: 'Parkeringsområdet är nu uppdaterat',
            parkingNotAllowed: 'Parkering ej tillåten',
            parkingFree: 'Gratis parkering',
            startDate: 'Startdatum',
            endDate: 'Slutdatum',
            period: 'Period',
            days: 'Dagar',
            time: 'Tider',
            parkingSpots: 'Platser',
            availableFor: 'Tillgänglig för',
            price: 'Pris',
            allDays: 'Alla',
            public: 'Alla',
            allParkingSpots: 'Alla',
            specificDays: 'Specifika dagar',
            community: 'Community',
            specificSpots: 'Specifika platser',
            removePriceRuleSetTitle: 'Ta bort?',
            removePriceRuleSetDescription: 'Är du säker på att du vill ta bort pris- & tillgänglighetsraden?',
            removedPriceRuleSetTitle: 'Borttaget',
            removedPriceRuleSetDescription: 'Tog bort pris & tillgänglighet',
            missingPriceRuleSets: 'Om du vill att kunder ska kunna boka parkeringar i AirPark appen behöver du lägga till pris och tillgänglighet',
            removedParkingSpotTitle: 'Borttagen',
            removedParkingSpotDescription: 'Tog bort parkeringsplats',
            removeParkingSpotTitle: 'Ta bort?',
            removeParkingSpotDescription: 'Är du säker på att du vill ta bort parkeringsplatsen?',
            approvedTitle: 'Godkänt',
            approvedDescription: 'Parkeringsområdet är nu godkänt av AirPark. Lägg till prisregler och tillgänglighet för att användare ska kunna boka i AirPark appen.',
            asDefinedByPeriod: 'Enligt perioden',
            removeParkingAreaTitle: 'Ta bort område',
            removeParkingAreaDescription: 'Är du säker på att du vill ta bort parkeringsområdet? Detta går inte att ångra!',
            ongoing: 'tillsvidare',
            removedParkingAreaTitle: 'Borttaget',
            removedParkingAreaDescription: 'Området är nu borttaget',
            videoInstructionsDescription: 'Se vår video om hur du ställer in pris- och tillgänglighetsregler',
          },
          addPriceRuleSet: {
            title: 'Lägg till pris & tillgänglighet',
            description: 'Beskrivning',
            from: 'Från',
            to: 'Till',
            pickParkingSpots: 'Välj parkering',
            all: 'Alla',
            specificSpots: 'Specifika platser',
            selectedNumberOfSpots: '{{number}} platser valda',
            onWeekdays: 'På veckodagar',
            public: 'Alla',
            community: 'Community',
            availability: 'Dagar',
            betweenDates: 'Alla',
            specificDays: 'Specifika dagar',
            save: 'Spara',
            between: 'Mellan',
            errorTitle: 'Något gick fel',
            errorName: 'Du måste lägga till beskrivning/namn',
            errorParkingSpots: 'Inga parkeringar valda',
            errorDateRange: 'Från datum måste vara mindre än till datum',
            errorPrice: 'Pris får inte vara tomt eller 0',
            priceRuleSetUpdatedTitle: 'Uppdaterat',
            priceRuleSetUpdatedDescription: '{{name}} är nu uppdaterat',
            priceRuleSetAddedTitle: 'Tillagt',
            priceRuleSetAddedDescription: '{{name}} är nu tillagt för parkeringsområdet',
            price: 'Pris',
            availableFor: 'Tillgänglig för',
            limitNumberOfHoursParkingIsAllowed: 'Begränsa hur länge man får parkera?',
            maxParkingTimeInHours: 'Max parkeringstid i timmar',
            tooltipAvailability: 'För alla dagar gäller pris och tillgänglighet för hela perioden oavsett veckodag. Välj specifika dagar om pris och tillgänglighet ska gälla för specifika dagar och tider inom tidsperioden. Exempelvis: Mån-Fre 18:00-21:00.',
            tooltipDescription: 'Ge pris och tillgängligheten ett namn eller beskrivning. Exempelvis: Mån-Fre 18:00-21:00 10kr/h. Detta syns enbart i portalen och inte i AirPark appen.',
            editTitle: 'Redigera pris & tillgänglighet',
            noEndDate: 'Tillsvidare',
            chooseCommunity: 'Välj community',
            noCommunitiesTitle: 'Inga communities',
            noCommunitiesDescription: 'Inga communities tillgängliga för parkeringsområdet. Skapa ett community på Community-sidan.',
            recurring: 'Upprepa',
            recurringTo: 'Upprepa till',
            between: 'Mellan',
            and: 'och',
            overlapMessage: 'Det finns redan en tillgänglighet som överlappar det angivna datumintervallet.'
          },
          selectParkingSpotsModal: {
            selectParkingSpots: 'Välj parkeringsplatser',
            selectParkingSpot: 'Välj parkeringsplats',
            yes: 'Ja',
            no: 'Nej',
            notNumbered: 'Ej numrerad',
            features: 'Egenskaper',
            locationSpecific: 'Platsspecifik',
            id: 'Id',
            objectId: 'Objekt-id',
            number: 'Nummer',
            numberOfParkingSpotsSelected: '{{number}} platser valda',
            noParkingSpotsAvailable: 'Inga parkeringsplatser tillgängliga',
            floor: 'Plan',
            price: 'Pris',
            unspecified: 'Ej angivet',
            provideNumberSeries: 'För att skapa numrerade platser måste du ange ett giltigt \'Från\'-nummer',
            searchPlaceholder: 'Sök på Plats-ID, Objekt-id, Platsnummer eller Plan',
            noSearchResults: 'Inga platser matchar sökningen'
          },
          selectCommunitiesModal: {
            selectCommunities: 'Välj Communities',
            selectCommunity: 'Välj Community',
            id: 'Id',
            name: 'Community namn',
            numberOfCommunitiesSelected: '{{number}} communities valda',
            numberOfMembers: 'Antal medlemmar',
            noCommunitiesAvailable: 'Inga communities tillgängliga',
          },
          editParkingSpotModal: {
            editParkingSpot: 'Redigera parkeringsplats',
            parkingSpotActive: 'Parkeringsplats tillgänglig',
            parkingSpotDisabled: 'Parkeringsplats otillgänglig',
            outdoors: 'Utomhus',
            indoors: 'Inomhus',
            fenced: 'Inhägnat',
            chargingPost: 'Laddbox',
            features: 'Egenskaper',
            description: 'Beskrivning',
            positionSpecific: 'Numrerad',
            position: 'Position',
            positionDescription: 'Om parkeringsplatsen är platsspecifik kan du ange en exakt position. Placera ut parkeringsplatsens pin genom att klicka på en position på kartan.',
            number: 'Nummer',
            floor: 'Plan',
            objectId: 'Objekt-id',
            objectIdDescription: 'Fastighetsägarens egen identifierare för parkeringsplatsen.',
            removePin: 'Ta bort pin',
            parkingSpotUpdatedTitle: 'Uppdaterad',
            parkingSpotUpdatedDescription: 'Parkeringsplatsen är uppdaterad',
            provideNumberSeries: 'För att skapa numrerade platser måste du ange ett giltigt nummer'
          },
          addParkingSpotsModal: {
            title: 'Lägg till parkeringsplatser',
            addedParkingSpotsTitle: 'Tillagda',
            addedParkingSpotsDescription: 'Parkeringsplatserna tillagda på parkeringsområdet'
          },
          editParkingArea: {
            approvalRequiredTitle: 'Godkännande kan krävas',
            approvalRequiredDescription: 'Om parkeringsområdets position ändras krävs det ett godkännande från AirPark. Under granskningsprocessen kommer det inte vara möjligt att genomföra nya bokningar i AirPark appen eller att utfärda nya tillstånd.',
            description: 'Beskrivning',
            updatedTitle: 'Uppdaterat',
            updatedDescription: 'Parkeringsområdet är nu uppdaterat.',
            updatedDescriptionRequiresApproval: 'Parkeringsområdet är nu uppdaterat och hos AirPark för granskning.',
            uploadImages: 'Ladda upp bilder',
            parkingAreaHasNoImages: 'Parkeringsområdet har inga bilder. Ladda upp bilder och spara för att förbättra presentationen i AirPark appen.',
            fieldsMissingTitle: 'Fält saknas',
            fieldsMissingDescription: 'Ett eller flera fält är inte korrekt ifyllda',
          },
          createPermitPage: {
            createTitle: 'Skapa tillstånd',
            issueTitle: 'Utfärda tillstånd',
            activateManualPermit: 'Aktivera manuellt tillstånd',
            manualActivation: 'Manuell aktivering',
            manualActivationEditModeTooltip: 'Kan inte ändras i redigeringsläge',
            manualActivationTooltip: 'Du måste ange all information om användaren med tillståndet och kommer inte att kunna lägga till telefonnummer.',
            phoneNumber: 'Mobilnummer till mottagaren',
            phoneNumberTooltip: 'Ett SMS med en länk till tillståndet kommer att skickas till mottagaren. Först när mottagaren har accepterat och genomfört en lyckad betalning för tillståndet blir det giltigt.',
            description: "Anteckning",
            descriptionPlaceholder: "t.ex. Jane Doe, Acme AB",
            descriptionTooltip: "Anteckningen syns bara i portalen. Mottagarens namn kommer att synas på tillståndet efter att det accepterats.",
            chooseParkingSpot: "Välj parkeringsplats",
            allParkingSpots: "Områdesparkering",
            specificParkingSpots: "Platsspecifik",
            period: 'Dagar',
            betweenDates: 'Alla',
            specificDays: 'Specifika dagar',
            tooltipPeriod: 'För alla dagar gäller tillståndet för hela den angivna perioden oavsett veckodag. Välj specifika dagar om tillståndet ska gälla för specifika dagar och tider inom tidsperioden. Exempelvis: Mån-Fre 18:00-21:00.',
            spotSelected: 'Plats vald',
            noSpotSelected: 'Ingen plats vald',
            from: 'Från',
            notNumbered: 'Ej numrerad',
            to: 'Till',
            onWeekdays: 'På veckodagar',
            between: 'Mellan',
            isSublettingAllowed: 'Får hyras ut i andrahand',
            canBeSublettedTo: 'Får hyras ut i andrahand till',
            isSublettingAllowedDescription: 'Välj om tillståndet kan hyras ut i andrahand. Tillståndet kan begränsas till att bara kunna hyras ut till de communities som parkeringsområdet är anslutet till.',
            isSublettingAllowedMarketplaceDescription: 'Välj om tillståndet kan hyras ut i andrahand. Om tillståndet enbart är tillgängligt på marketplace för communities som parkeringsområdet är anslutet till kommer det enbart att kunna hyras ut i andrahand till medlemmar i dessa communities.',
            everyone: 'Publikt',
            invoicedBy: 'Fakturering hanteras av',
            externally: 'Annan part',
            price: 'Pris',
            invoicedByTooltip: 'Välj hur fakturering av tillståndet ska hanteras. AirPark kan sköta fakturering av tillståndet mot slutkund och automatiskt uppdatera tillståndets giltighet. Annan part kan även sköta faktureringen men då behöver tillståndets giltighet hanteras manuellt.',
            invoicedExternallyTitle: 'Annan part',
            invoicedExternallyDescription: 'Faktureringen sköts av annan part. All administration av fakturering och hantering av tillståndets giltighet kopplat till genomförda betalningar behöver hanteras manuellt eller av annan part.',
            community: 'Communities',
            noEndDate: 'Tillsvidare',
            permitCreatedTitle: 'Tillstånd skapat',
            permitActivatedTitle: 'Tillstånd aktiverat',
            permitActivatedDescription:' Tillståndet är nu aktiverat och giltigt.',
            permitCreatedManualActivationDescription: 'Tillståndet har skapats och måste aktiveras manuellt',
            permitCreatedDescription: 'Tillstånd skapat och ett SMS har skickats till {{phone}} med en inbjudningslänk. När mottagaren har accepterat tillståndet kommer dennes namn att synas på tillståndet.',
            editTitle: 'Redigera tillstånd',
            permitUpdatedTitle: 'Uppdaterat',
            permitUpdatedDescription: 'Tillståndet är nu uppdaterat.',
            marketplaceAvailability: 'Tillgängligt på marketplace för',
            reAddToMarketplace: 'Lägg upp tillstånd på marketplace igen',
            reAddToMarketplaceTooltip: 'Välj om tillståndet ska läggas upp på marketplace igen vid avslut av befintligt tillstånd. Den här inställningen kan åsidosättas vid avslut av individuella tillstånd.',
            requiresContractCode: 'Kräver kontraktskod',
            requiresContractCodeTooltip: 'Om aktiverad måste användare ange en giltig kontraktskod från fastighetsägaren för att ta tillståndet.',
            marketplacePermitCreatedTitle: 'Tillstånd skapat',
            marketplacePermitCreatedDescription: 'Tillståndet skapat och tillgängligt på marketplace.',
            marketplacePermit: 'Välj om tillståndet ska vara tillgängligt på marketplace att köpas av alla användare eller om det ska vara tillgängligt för medlemmar i communities som är anslutna till parkeringsområdet.',
            addUserToCommunity: 'Lägg till mottagare i communities',
            addUserToCommunityTooltip: 'Välj om mottagaren automatiskt ska läggas till i parkeringsområdets communities i samband med att parkeringstillståndet accepteras.',
            noCommunitiesFoundTitle: 'Inga communities hittades',
            noCommunitiesFoundDescription: 'Parkeringsområdet har inga communities. Gå till Community och skapa ett community för att kunna lägga till mottagare i communities.',
            userWillBeAddedToCommunitiesTitle: 'Communities',
            userWillBeAddedToCommunitiesDescription: 'Mottagaren kommer att läggas till i följande communities: {{communities}}',
            pleaseChooseCommunities: 'Vänligen välj communities',
            issue: 'Utfärda',
            parkingSpots: 'Parkeringsplatser',
            specialRequests: 'Särskilda önskemål',
            contractCode: 'Kontraktskod',
            noContractCode: 'Ingen kontraktskod',
          },
          permitsPage: {
            permitsPageTitle: 'Parkeringstillstånd',
            permitsPageDescription: 'Administera och utfärda parkeringstillstånd för parkeringsområdet eller enskilda parkeringsplatser. När ett parkeringstillstånd utfärdas får användaren ett SMS med en inbjudningslänk där tillståndet kan aktiveras.',
            addPermitTitle: 'Tillstånd',
            createPermit: 'Utfärda',
            bulkCreate: 'Massskapa',
            downloadCSV: 'Ladda ner CSV',
            expired: 'Utgångna',
            unpaid: 'Obetalda',
            cancelled: 'Avslutade',
            activePermits: 'Aktiva tillstånd',
            parkingSpotsWithoutPermits: 'Parkeringplatser utan tillstånd',
            permitsInMarketplace: 'Tillgängliga på marketplace',
            videoInstructionsDescription: 'Se vår video om hur du utfärdar parkeringstillstånd',
            selectColumns: 'Välj kolumner för CSV',
            manualActivateTitle: 'Manuell aktivering av tillstånd',
            manualActivateDescription: 'Det manuella tillståndet har skapats.'
          },
          contractCodesPage: {
            title: 'Kontraktskoder',
            description: 'Hantera kontraktskoder för marketplace-tillstånd. Användare kan hämta ett tillstånd genom att ange en giltig kontraktskod.',
            tabOverview: 'Översikt',
            tabUpload: 'Ladda upp koder',
            tabScheduled: 'Schemalagda byten',
            totalCodes: 'Totalt antal koder',
            usedCodes: 'Använda koder',
            availableCodes: 'Tillgängliga koder',
            availablePermits: 'Tillgängliga tillstånd',
            uploadTitle: 'Ladda upp koder',
            selectPermit: 'Välj tillstånd',
            uploadCsv: 'Ladda upp Excel-fil (.xlsx)',
            downloadTemplate: 'Ladda ner Excel-mall',
            helpMobilnumber: 'Mobilnummer: om ifyllt aktiveras tillståndet automatiskt på användaren med det numret (SMS/push skickas).',
            helpRegnumber: 'Regnummer: förifyller fordonet. Om tomt och mobilnummer är satt måste kunden själv lägga till fordonet i appen — annars risk för parkeringsbot.',
            csvPlaceholder: 'Ange en kod per rad, eller ladda upp en CSV-fil...',
            noPermitsWithContractCode: 'Inga tillstånd med kontraktskodkrav',
            selectPermitAndCodes: 'Välj ett tillstånd och ange koder',
            noCodesFound: 'Inga koder hittades i inmatningen',
            uploadSuccess: '{{added}} koder tillagda, {{skipped}} överhoppade (dubbletter)',
            codesList: 'Koder',
            code: 'Kod',
            permit: 'Tillstånd',
            usedBy: 'Använd av',
            usedAt: 'Använd',
            noCodes: 'Inga kontraktskoder hittades. Ladda upp koder ovan.',
            inactive: 'Inaktiv',
            used: 'Använd',
            available: 'Tillgänglig',
            reset: 'Återställ',
            codeReset: 'Koden har återställts och kan användas igen',
            codeRevoked: 'Koden har återkallats',
            issue: 'Utfärda',
            issueTitle: 'Utfärda tillstånd',
            issueDescription: 'Utfärda ett tillstånd med koden: {{code}}',
            noAvailablePermits: 'Inga lediga marketplace-tillstånd med kontraktskodkrav. Skapa ett marketplace-tillstånd först.',
            availablePermitsInfo: '{{count}} tillstånd tillgängliga att utfärda',
            recipientPhone: 'Mottagarens mobilnummer',
            phoneRequired: 'Mobilnummer krävs',
            issueSuccess: 'Tillstånd utfärdat till {{userName}}',
            showInactive: 'Visa inaktiva ({{count}})',
            reactivate: 'Återaktivera',
            codeReactivated: 'Koden har återaktiverats',
            delete: 'Radera',
            deleteConfirm: 'Är du säker på att du vill radera denna kod permanent? Detta kan inte ångras.',
            codeDeleted: 'Koden har raderats permanent',
            inactiveCodes: 'Inaktiva koder',
            inactivate: 'Inaktivera',
            selectPermitSpot: 'Välj plats',
            noPermitSelected: 'Välj en plats',
            licensePlate: 'Registreringsnummer',
            licensePlateRequired: 'Registreringsnummer krävs',
            uploadFormat: 'En kod per rad. Ange valfritt ett mobilnummer i andra kolumnen och registreringsnummer i tredje kolumnen (komma, semikolon eller tab). Mobilnummer måste ha landskod (+46701234567) eller börja med 0 (konverteras automatiskt).',
            uploadFormatExample: 'Exempel: "A101" eller "A101,+46701234567" eller "A101,+46701234567,ABC123"',
            notEnoughPermits: 'Filen innehåller {{phoneCount}} mobilnummer men det finns bara {{available}} lediga tillstånd. Skapa fler tillstånd eller ta bort mobilnummer från filen.',
            csvGuide: 'Hur exporterar jag från Excel?',
            csvGuideStep1: 'Öppna filen i Excel',
            csvGuideStep2: 'Klicka Arkiv → Spara som',
            csvGuideStep3: 'Välj format: CSV UTF-8 (kommaavgränsad) (.csv)',
            csvGuideStep4: 'Klicka Spara',
            csvGuideAlt: 'Alternativt: ladda upp Excel-filen (.xlsx) direkt — portalen läser den automatiskt.',
            previewCodes: '{{count}} koder hittades.',
            duplicatesWarning: '{{count}} dublettkoder hittades — de kommer inte att läsas in.',
            previewLoading: 'Räknar ut förhandsgranskning mot systemdata…',
            previewError: 'Kunde inte generera förhandsgranskning. Försök igen eller ta bort rader.',
            xlsxParseError: 'Filen kunde inte läsas. Kontrollera att det är en giltig Excel-fil.',
            previewSummaryHeader: 'Kommer behandla {{total}} rader för {{area}}',
            previewSummaryAdd: '{{count}} nya öppna koder skapas (vem som helst kan claima i appen).',
            previewSummaryIssue: '{{count}} tillstånd utfärdas ({{existing}} till befintliga users, {{stub}} till stub-users som måste registrera sig i appen).',
            previewSummaryVehicles: '{{count}} nya fordon kommer skapas.',
            previewSummaryDupFile: '{{count}} dubbletter inom filen hoppas över.',
            previewSummaryDupDb: '{{count}} koder finns redan på området och hoppas över.',
            previewSummaryErrors: '{{count}} rader är ogiltiga (saknad kod, etc).',
            previewColAction: 'Action',
            previewColCode: 'Kod',
            previewColExplanation: 'Vad som händer',
            actionAdd: 'Skapa (öppen)',
            actionAddAndIssue: 'Skapa + utfärda',
            actionAddIssueCreateUser: 'Skapa + utfärda + ny user',
            actionSkipDupFile: 'Hoppas över — dubblett i fil',
            actionSkipDupDb: 'Hoppas över — finns redan',
            actionError: 'Fel — hoppas över',
            searchPermitPlaceholder: 'Sök plats (Plats-ID, platsnummer eller Objekt-id)',
            searchingPermits: 'Söker…',
            permitsShownOf: '{{shown}} av {{total}} platser visas',
            spotIdLabel: 'Plats-ID',
            spotNumberLabel: 'Plats',
            objectIdLabel: 'Objekt-id',
            chooseFile: 'Välj fil (.csv, .xlsx)',
            removeFile: 'Ta bort fil',
            typeManually: 'Eller skriv/klistra in koder manuellt',
            manualInput: 'Manuell inmatning',
            manualInputFormatHeading: 'Format (en per rad):',
            manualInputFormatExample1: 'bara kod (öppen — kunden matar in den i appen)',
            manualInputFormatExample2: 'kod + mobilnummer (aktiveras automatiskt)',
            manualInputFormatExample3: 'kod + mobil + regnummer (förifyllt fordon)',
            columnMapping: 'Kolumnmappning',
            hasHeader: 'Filen har rubrikrad',
            codeColumn: 'Kodkolumn',
            phoneColumn: 'Telefonnummerkolumn',
            noPhoneColumn: 'Ingen',
            phoneValidationOk: '{{count}} giltiga telefonnummer',
            phoneValidationWarning: '{{valid}} giltiga telefonnummer, {{invalid}} okända värden (hoppas över)',
            previewRows: 'Förhandsgranskning',
            previewRowsMore: '... och {{count}} rader till',
            uploadWithPhones: '{{phoneCount}} mobilnummer hittades — tillstånd utfärdas automatiskt.',
            issueSuccessCount: '{{count}} tillstånd utfärdades.',
            uploadStep1Title: 'Förstå format',
            uploadStep2Title: 'Välj fil',
            uploadStep3Title: 'Mappa kolumner',
            uploadStep4Title: 'Förhandsgranska',
            uploadStep5Title: 'Klart',
            uploadStep1Heading: 'Så här fungerar uppladdningen',
            uploadStep2Heading: 'Ladda upp Excel-fil',
            uploadStep2Description: 'Välj Excel-filen (en kod per rad) eller skriv/klistra in koder manuellt.',
            uploadStep3Heading: 'Mappa kolumner',
            uploadStep3Description: 'Bekräfta vilka kolumner som innehåller koden, telefonnumret och registreringsnumret.',
            uploadStep4Heading: 'Förhandsgranska',
            uploadStep4Description: '{{count}} rader redo att bearbetas. Granska resultatet mot systemdata och ladda sedan upp.',
            uploadContinue: 'Fortsätt',
            uploadBack: 'Tillbaka',
            uploadAnother: 'Ladda upp en till',
            uploadDoneTitle: 'Koder uppladdade',
            fileLoadedRows: '{{count}} rader inlästa',
            filterLabel_available: 'Endast tillgängliga',
            filterLabel_used: 'Endast använda',
            filterLabel_scheduled: 'Endast schemalagda byten',
            filterLabel_inactive: 'Endast inaktiva',
            clearFilter: 'Rensa filter',
            scheduledTransitions: 'Schemalagda byten',
            queued: 'Köad',
            scheduleTransition: 'Schemalägg byte',
            cancelTransition: 'Avbryt byte',
            cancelTransitionConfirm: 'Är du säker på att du vill avbryta det schemalagda bytet?',
            transitionCancelled: 'Det schemalagda bytet har avbrutits',
            scheduleTransitionTitle: 'Schemalägg hyresgästbyte',
            scheduleTransitionDescription: 'Schemalägg ett hyresgästbyte för koden: {{code}}. Koden används idag av {{currentUser}}.',
            newTenantPhone: 'Ny hyresgästs mobilnummer',
            activeDate: 'Aktiveringsdatum',
            activeDateRequired: 'Aktiveringsdatum krävs',
            scheduleTransitionInfo: 'Vid midnatt på valt datum kommer koden automatiskt att överföras till den nya hyresgästen och tillståndet tilldelas om.',
            schedule: 'Schemalägg',
            scheduleSuccess: 'Byte schemalagt för {{userName}} den {{date}}',
            editTransition: 'Redigera',
            editTransitionTitle: 'Redigera schemalagt byte',
            editTransitionDescription: 'Redigera det schemalagda bytet för koden: {{code}}. I kö just nu: {{currentQueued}}.',
            saveChanges: 'Spara ändringar',
            lookupVehicles: 'Sök fordon',
            vehicle: 'Fordon (valfritt)',
            noVehicle: 'Inget fordon — användaren lägger till i appen',
            addNewVehicle: '+ Lägg till nytt fordon',
            add: 'Lägg till',
            vehicleCreated: 'Fordon {{plate}} tillagt',
            regPlateColumn: 'Registreringsnummerkolumn',
            uploadWithRegPlates: '{{count}} registreringsnummer hittades — fordon skapas automatiskt.',
            queuedUser: 'Köad användare',
            licensePlateOptional: 'Registreringsnummer (valfritt)',
            regPlateOptionalInfo: 'Användaren uppmanas ange registreringsnummer när hen loggar in i appen.',
            userNotRegistered: 'Denna användare har inte AirPark-appen. Tillståndet kommer att skapas och användaren uppmanas att registrera sig och ange registreringsnummer när hen öppnar appen.',
            resetConfirm: 'Är du säker på att du vill återställa denna kod? Koden blir tillgänglig för en ny användare. Obs: tillståndet som är kopplat till koden förblir aktivt — avsluta tillståndet manuellt vid behov.',
            vehicleCreateError: 'Kunde inte skapa fordonet. Kontrollera registreringsnumret och försök igen.',
          },
          inputPhoneNumber: {
            chooseCountryRegion: 'Välj land/region'
          },
          bulkCreateModal: {
            title: 'Skapa många marketplace-tillstånd',
            communityExtIdsPlaceholder: 'Community ExtIds (kommaseparerade)',
            selectSpots: 'Välj parkeringsplatser',
            selectAll: 'Välj alla',
            deselectAll: 'Avmarkera alla',
            noSpotsAvailable: 'Inga lediga parkeringsplatser (alla platser har redan tillstånd).',
            noSpotsSelected: 'Välj minst en plats.',
            spotsSelected: '{{count}} platser valda',
            settings: 'Tillståndsinställningar',
            paymentManual: 'Betalning hanteras utanför AirPark',
            price: 'Pris',
            startDate: 'Startdatum',
            openEnded: 'Tillsvidare (inget slutdatum)',
            endDate: 'Slutdatum',
            requiresContractCode: 'Kräver kontraktskod',
            communityOnly: 'Endast community',
            subletting: 'Andrahandsuthyrning tillåten',
            createButton: 'Skapa {{count}} tillstånd',
            created: '{{count}} tillstånd skapades.',
            priceRequired: 'Pris krävs när betalning inte hanteras manuellt.',
          },
          smsStatus: {
            failed: 'Ej levererat',
            retrying: 'Skickar…',
            pending: 'Väntar',
            retryingTip: 'SMS:et har inte levererats än — systemet försöker igen.',
            pendingTip: 'SMS-inbjudan har inte skickats än.',
            reason: {
              landline: 'Numret är ett fast telefonnummer och kan inte ta emot SMS. Be mottagaren om ett mobilnummer.',
              invalid: 'Numret är ogiltigt eller felaktigt skrivet. Kontrollera numret och försök igen.',
              unsubscribed: 'Mottagaren har avregistrerat sig från SMS (svarat STOP).',
              unreachable: 'Numret går inte att nå via SMS.',
              unknown: 'SMS:et kunde inte skickas.',
            },
          },
          permitTable: {
            notAcceptedYet: 'Väntar på att accepteras',
            name: 'Namn',
            description: 'Anteckning',
            spotIdentifier: 'Platsnummer',
            objectId: 'Objekt-id',
            timePeriod: 'Period',
            id: 'Id',
            status: 'Status',
            firstName: 'Förnamn',
            lastName: 'Efternamn',
            email: 'E-post',
            phoneNumber: 'Telefonnummer',
            licensePlateNumber: 'Registeringsnummer',
            period: 'Giltighetstid',
            time: 'Tid',
            price: 'Pris',
            subletting: 'Andrahandsuthyrning',
            duplicate: 'Duplicera',
            revoke: 'Avsluta',
            days: 'Dagar',
            parkingArea: 'Områdesparkering',
            noPermits: 'Inga tillstånd utfärdade. Klicka på Skapa för att utfärda ett nytt tillstånd.',
            noMarketplacePermits: 'Inga tillstånd tillgängliga på marketplace.',
            noPermitsFound: 'Inga tillstånd hittades.',
            active: 'Aktivt',
            pending: 'Inbjudan skickad',
            upcoming: 'Kommande',
            allowed: 'Tillåtet',
            notallowed: 'Ej tillåtet',
            invoicedBy: 'Faktureras av',
            thirdParty: 'Annan part',
            revokePermitTitle: 'Avsluta tillståndet?',
            revokePermitDescription: 'Tillståndet kommer att återkallas den {{date}}. Observera att om tillståndet ska ha ett annat slutdatum kan du ställa in det nedan. {{note}}',
            revokePermitDescriptionWithoutDateOption: 'Tillståndet kommer att återkallas den {{date}}. {{note}}',
            revokePermitEndDateNote: 'Observera att det aktuella slutdatumet för tillståndet är {{endDate}}.',
            revokedPermitTitle: 'Tillstånd avslutat',
            revokedPermitDescription: 'Tillståndet är nu avslutat och inte giltigt längre.',
            expired: 'Avslutat',
            ongoing: 'tillsvidare',
            marketplace: 'Tillgängligt på marketplace',
            availability: 'Tillgängligt för',
            community: 'Community',
            everyone: 'Publikt',
            deletePermitTitle: 'Ta bort?',
            deletePermitDescription: 'Detta kommer att ta bort tillståndet.',
            deletedTitle: 'Borttaget',
            deletedDescription: 'Tillstånd borttaget.',
            reAddToMarketplace: 'Lägg upp på marketplace igen',
            reAddToMarketplaceTooltip: 'Tillståndet kommer att läggas till på marketplace direkt med startdatum den {{startDate}}.',
            isFromMarketplace: "Är ett marketplace tillstånd",
            revokeDate: 'Datum för återkallning',
            revokedOrCancelled: 'Återkallad/Avslutad',
            manualactivation: 'Manuell aktivering',
            contractCode: 'Kontraktskod',
          },
          permitHistory: {
            menuItem: 'Ändringslogg',
            title: 'Ändringslogg',
            selectedPermit: 'Tillstånd',
            by: 'Av',
            empty: 'Inga ändringar har loggats för det här tillståndet ännu.',
            error: 'Kunde inte ladda ändringsloggen. Försök igen.',
            vehicleChanged: 'Reg.nr ändrat {{from}} → {{to}}',
            permitEnded: 'Tillstånd avslutat',
            inviteSent: 'Tillstånd skickat',
            actor: {
              customer: 'kund',
              operator: 'operatör',
              'system-job': 'system',
            },
          },
          dropDownMultiSelector: {
            filter: 'Filtrera'
          },
          verifyEmailPage: {
            verifyEmailTitle: 'Bekräfta e-postadress',
            verifyEmailDescription: 'Bekräfta din e-postadress genom att klicka på länken som skickades till {{email}}',
            emailCouldNotBeVerifiedTitle: 'Ej verifierad',
            emailCouldNotBeVerifiedDescription: 'E-postadressen har inte kunnat verifieras. Vänligen försök igen.',
            noVerificationEmailReceivedTitle: 'Inte fått e-postmeddelandet?',
            noVerificationEmailReceivedDescription: 'Kontrollera din skräppost-mapp först. Om du fortfarande inte hittar e-postmeddelandet kan du skicka ett nytt.',
            resendVerificationEmail: 'Skicka nytt e-postmeddelande',
            emailResentTitle: 'E-postmeddelande skickat',
            emailResentDescription: 'Ett nytt e-postmeddelande har skickats till {{email}}'
          },
          login: {
            loginInProgress: 'Loggar in...'
          },
          permitMarketplacePage: {
            title: 'Marketplace',
            create: 'Skapa ett',
            bulkCreate: 'Skapa flera',
            description: 'Lägg upp tillgängliga parkeringstillstånd i AirPark Marketplace och hyr ut dem direkt till kunder. Du väljer själv om tillstånden ska vara publika eller enbart synliga för användare inom ditt community.',
            showingOf: 'Visar {{from}}-{{to}} av {{total}}',
            previous: 'Föregående',
            next: 'Nästa'
          },
          permitShare: {
            shareTitle: 'Dela tillstånd',
            shareDescription: 'Dela en länk till tillståndet. Skicka via e-post eller dela på sociala kanaler som exempelvis Facebook.',
            createdTitle: 'Tillstånd skapat',
            createdDescription: 'Tillståndet är skapat och tillgängligt på marketplace i AirPark appen. Det går även att dela tillståndet via e-post eller sociala kanaler som exempelvis Facebook med länken nedan.',
            updatedTitle: 'Tillstånd uppdaterat',
            updatedDescription: 'Tillståndet är uppdaterat och tillgängligt på marketplace i AirPark appen. Det går även att dela tillståndet via e-post eller sociala kanaler som exempelvis Facebook med länken nedan.',
            copyLink: 'Kopiera länk till urklipp',
            linkCopiedTitle: 'Kopierad',
            linkCopiedDescription: 'Länken är kopierad till urklipp'
          },
          settingsPage: {
            title: 'Inställningar',
            description: 'Hantera inställningarna för din organisation.',
            name: 'Namn',
            organizationNumber: 'Organisations- eller personnummer',
            address: 'Adress',
            zipCode: 'Postnummer',
            city: 'Stad',
            country: 'Land',
            phoneNumber: 'Telefonnummer',
            email: 'E-post',
            organizationUpdatedTitle: 'Uppdaterat',
            organizationUpdatedDescription: 'Organisationen är nu uppdaterad',
            vatPercentage: 'Moms i procent',
            selfBilling: 'Självfakturering',
            invoiceEmail: 'E-post för fakturor',
            selfBillingTooltip: 'Självfakturering innebär att du själv måste redovisa moms till Skatteverket. Om du inte väljer självfakturering redovisar AirPark hela momsen. Observera att självfakturering enbart är tillgängligt för momsregisterade bolag.',
            signAndSave: 'Signera och spara',
            taxIdentificationNumber: 'Momsregistreringsnummer',
            sign: 'Signera',
            signatureError: 'Signaturen är ogiltig, försök igen. Kontakta supporten om problemet kvarstår. ({{supportEmail}})'
          },
          payoutSettingsPage: {
            stripeTitle: 'Utbetalningskonto',
            stripeDescription: 'AirPark använder den globala betalningsleverantören Stripe för utbetalningar.',
            stripeNotConfiguredTitle: 'Stripe är inte konfigurerat',
            stripeNotConfiguredDescription: 'Stripe är inte konfigurerat för din organisation. För att kunna ta emot utbetalningar behöver Stripe konfigureras.',
            configureStripe: 'Konfigurera Stripe',
            payoutDayOfMonthAndMinimumValueTitle: 'Utbetalningsdag och minimibelopp',
            payoutDayOfMonthAndMinimumValueDescription: 'Vilken dag i månaden utbetalningar görs och minimibeloppet för utbetalning.',
            minimumPayoutValueErrorTitle: 'Minimibeloppet är för lågt',
            minimumPayoutValueErrorDescription: 'Minimibeloppet för utbetalning måste vara minst 300.',
            stripeConfiguredTitle: 'Stripe konfigurerat',
            stripeConfiguredDescription: 'Stripe är konfigurerat och kopplat till ditt AirPark-konto. Din organisation kan nu ta emot betalningar.',
            payoutDayOfMonth: 'Utbetalningsdag',
            minimumPayoutValue: 'Minimibelopp för utbetalning',
            minimumPayoutValueTooltip: 'Minimibeloppet för utbetalning är det lägsta beloppet som kan utbetalas. Om det totala intäktsbeloppet för en månad är lägre än minimibeloppet för utbetalning kommer intäkterna att samlas ihop till nästa månad.',
            dac7title: 'DAC7',
            dac7description: 'För att AirPark ska kunna genomföra utbetalningar av dina intäkter är det nödvändigt att du fyller i de ovanstående uppgifterna.\n\nVi samlar in dessa uppgifter för att säkerställa att vi följer DAC7, den nya EU-lagen som trädde i kraft den 1 januari 2023 och som kräver att vi rapporterar intäkter från parkeringsuthyrning till Skatteverket.\n\nOm du önskar aktivera självfakturering, behöver du även ange ditt momsregistreringsnummer.\n\nGenom att fylla i dessa uppgifter och signera med BankID, försäkrar du oss om att informationen är korrekt och aktuell.',
            sign: 'Signera',
            dac7NotSignedTitle: 'Ej signerat',
            dac7NotSignedDescription: 'Uppgifterna är inte signerade med BankID. För att kunna ta emot utbetalningar och för självfakturering krävs att uppgifterna har blivit signerade.',
            dac7SignedTitle: 'Signerat',
            dac7SignedDescription: 'Uppgifterna är signerade med BankID.',
          },
          revenueSharingSettingsPage: {
            revenueSharingTitle: 'Intäktsdelning',
            revenueSharingDescription: 'Konfigurera hur intäktsdelningen ska fungera för andrahandsuthyrning för din organisation. Observera att intäktsfördelningen är efter AirParks avgifter.',
            revenueSharingSublettingTitle: 'Andrahandsuthyrning',
            forYou: 'Till dig',
            subletter: 'Uthyraren',
            shareIsNotValidTitle: 'Intäktsdelningen är inte giltig',
            shareIsNotValidDescription: 'Intäktsdelningen är inte giltig. Observera att summan av andelar för alla roller måste vara 100%.',
            
          },
          usersPage: {
            title: 'Hantera användare',
            description: 'Hantera användare som ska ha tillgång till din organisation. En portaladministratör kan se och administrera allt i er portal, en andrahandsuthyrare kan ange er organisation som mottagare av utbetalningar vid andrahandsuthyrning.',
            users: 'Användare',
            portalAdministrators: "Portaladministratörer",
            sublessors: "Andrahandsuthyrare",
            invites: 'Väntande inbjudningar',
          },
          usersTable: {
            firstName: 'Förnamn',
            lastName: 'Efternamn',
            email: 'E-post',
            phone: 'Telefonnummer',
            removeUserTitle: 'Ta bort användare?',
            removeUserDescription: 'Är du säker på att du till ta bort användaren? Användaren förlorar all behörighet till organisationen.',
            removedUserTitle: 'Användare borttagen',
            removedUserDescription: 'Användaren har nu blivit borttagen från organisationen',
            contact: 'Kontakt',
            invitationStatus: "Status",
            sent: "Skickat",
            accepted: "Accepterad",
            accessLevel: "Åtkomstnivå",
            sublessor: "Andrahandsuthyrare",
            portalAdmin: "Portal admin",
          },
          invitesTable: {
            phone: 'Telefonnummer',
            status: 'Status',
            issuedBy: 'Utfärdat av',
            contact: 'Kontakt',
            noInvites: 'Inga väntande inbjudningar',
            deleteInviteTitle: 'Ta bort inbjudan?',
            deleteInviteDescription: 'Är du säker på att du vill ta bort inbjudan? Detta kan inte ångras.',
            removedInviteTitle: 'Inbjudan borttagen',
            removedInviteDescription: 'Inbjudan har nu blivit borttagen',
            sentAt: 'Skickad',
          },
          inviteUserModal: {
            title: 'Bjud in användare',
            descriptionPortalAdmin: 'Skicka en inbjudan till användaren du vill bjuda in som portaladministratör.',
            descriptionSublessor: 'Skicka en inbjudan till användaren du vill bjuda in som andrahansuthyrare.',
            userInvitedTitle: 'Användaren inbjuden',
            userInvitedDescription: 'Användaren har blivit inbjuden till din organisation.',
            portalAdmin: "Portal admin",
            sublessor: "Andrahandsuthyrare",
          },
          inviteSublessorModal: {
            userInvitedTitle: 'Användare inbjuden',
            userInvitedDescription: 'Användaren har blivit inbjuden till din organisation som andrahandsuthyrare.'
          },
          organizationInvitationPage: {
            youveBeenInvitedTitle: 'Du har blivit inbjuden',
            youveBeenInvitedDescription: 'Du har blivit inbjuden att gå med i {{organizationName}} organisationen.',
            useEmail: 'Logga in eller registrera dig med e-postadressen',
            acceptInvite: 'Acceptera inbjudan',
            invitationNotFoundTitle: 'Hittades inte',
            invitationNotFoundDescription: 'Tyvärr, inbjudan kan inte hittas.',
            emailDoesNotMatchTitle: 'Fel e-post',
            emailDoesNotMatchDescription: 'E-postadressen du har loggat in med stämmer inte överens med e-postadressen som inbjudan skickades till.',
            emailNotVerifiedTitle: 'Inte verifierad',
            emailNotVerifiedDescription: 'Du behöver verifiera din e-post innan du kan acceptera inbjudan.'
          },
          communityPage: {
            title: 'Community',
            description: 'Communities kan skapas för parkeringsområdet och användas för att styra vilka priser, tillgängligheter och tillstånd som är giltiga för vem. Dessa communities kan sedan kopplas samman med andra communities för att utöka tillgängligheten för dina community-medlemmar.',
            communitiesTitle: 'Mina communities',
            addExistingCommunity: 'Lägg till befintligt community',
            videoInstructionsDescription: 'Se vår video om vad communities är och hur du använder dem.',
          },
          createCommunityPage: {
            title: 'Skapa community',
            name: 'Namn',
            description: 'Beskrivning',
            photos: 'Ladda upp bild',
            photosTooltip: 'Ladda upp en bild som representerar ditt community. Det går bara att ladda upp en bild.',
            invalidFileType: 'Ogiltigt filformat. Tillåtna: JPG, PNG, GIF.'
          },
          communitiesTable: {
            name: 'Namn',
            numberOfMembers: 'Antal medlemmar',
            description: 'Beskrivning',
            noCommunities: 'Inga communities',
            manageMembers: 'Hantera medlemmar',
            editCommunity: 'Redigera community',
          },
          manageCommunityPage: {
            title: 'Redigera community',
            uploadPhotos: 'Ladda upp bild',
            photos: 'Bild',
            photosTooltip: 'Ladda upp en bild som representerar ditt community. Det går bara att ladda upp en bild.',
            noPhotos: 'Ingen bild har laddats upp för detta community',
            communityUpdatedTitle: 'Community uppdaterat',
            communityUpdatedDescription: 'Community är nu uppdaterat'
          },
          manageCommunityMembersPage: {
            title: 'Hantera community-medlemmar',
            members: 'Medlemmar',
            inviteMember: 'Bjud in medlem',
            phoneNumber: 'Telefonnummer',
            pendingInvites: 'Väntande inbjudningar',
            phoneNumberMissingTitle: 'Telefonnummer saknas',
            phoneNumberMissingDescription: 'Ett telefonnummer krävs för att skicka en inbjudan',
            invitationSentTitle: 'Inbjudan skickad',
            invitationSentDescription: 'Inbjudan skickad till användaren',
            sendPhoneInvitationTitle: 'Skicka SMS-inbjudan',
            sendPhoneInvitationDescription: 'Skicka en inbjudan till användaren via SMS',
            createLinkInvitationTitle: 'Skapa inbjudningslänk',
            createLinkInvitationDescription: 'Skapa en inbjudan som kan skickas till användaren med exempelvis e-post. Länken kan användas flera gånger och är giltig tills den tas bort.',
            invitationLinkCreatedTitle: 'Inbjudningslänk skapad',
            invitationLinkCreatedDescription: 'Inbjudningslänken har nu skapats',
            noInvitationLinksCreated: 'Inga inbjudningslänkar har skapats',
          },
          communityMembersTable: {
            firstName: 'Förnamn',
            lastName: 'Efternamn',
            phoneNumber: 'Telefonnummer',
            noMembers: 'Inga medlemmar'
          },
          communityInviteLinksTable: {
            link: 'Länk',
            noLinks: 'Inga länkar',
          },
          connectedCommunitiesTable: {
            communityName: 'Mitt community',
            connectedCommunityName: 'Anslutet till',
            noConnectedCommunities: 'Inga anslutna communities',
            deleteCommunityConnectionTitle: 'Ta bort communities-anslutning',
            deleteCommunityConnectionDescription: 'Är du säker på att du vill ta bort communities-anslutningen?',
            removedCommunityConnectionTitle: 'Communities-anslutning borttagen',
            removedCommunityConnectionDescription: 'Communities-anslutningen har nu blivit borttagen'
          },
          createConnectCommunityRequestModal: {
            title: 'Anslut till community',
            stepsStart: 'För att hitta ett parkeringsområde och ansluta till ett community, följ dessa steg:',
            stepOne: 'Använd kartan för att hitta ett parkeringsområde och community som du vill ansluta till. Efter att du har valt ett område visas en lista över communities.',
            stepTwo: 'Välj det community som du vill ansluta till. Om du har fler än ett community måste du välja vilken av dina communities du vill skapa anslutningen för.',
            stepThree: 'Skicka förfrågan till community. Communityt kommer då att kunna acceptera eller avböja förfrågan.',
            stepsEnd: 'Om förfrågan accepteras kommer du att kunna se communities i listan över anslutna communities.',
            sendConnectRequest: 'Skicka anslutningsförfrågan',
            selectCommunity: 'Välj community att be om anslutning med',
            selectYourCommunity: 'Välj vilken av dina communities du vill begära anslutning för',
            noCommunitySelectedTitle: 'Ingen community vald',
            noCommunitySelectedDescription: 'Använd kartan för att hitta och välja ett parkeringsområde och community att ansluta till.',
            youCantConnectWithYourOwnParkingAreaTitle: 'Det går inte',
            youCantConnectWithYourOwnParkingAreaDescription: 'Du kan inte ansluta till din eget parkeringsområde.',
            noCommunitiesCreatedForParkingAreaTitle: 'Inga communities',
            noCommunitiesCreatedForParkingAreaDescription: 'Det finns inga communities som skapats för ditt parkeringsområde. Skapa en community först och försök sedan igen.',
            connectRequestSentTitle: 'Förfrågan skickad',
            connectRequestSentDescription: 'Förfrågan skickad till community. Community kommer att kunna acceptera eller avböja förfrågan.',
          },
          communityConnectionsPage: {
            title: 'Sammanlänkade communities',
            description: 'Sammanlänkade communities kan användas för att utöka tillgängligheten för dina community-medlemmar.',
            sentRequests: 'Skickade förfrågningar',
            receivedRequests: 'Mottagna förfrågningar',
            connectedCommunitiesTitle: 'Sammanlänkade communities',
            connect: 'Skicka länkförfrågan',
            pendingRequests: 'Väntande förfrågningar',
          },
          sentRequestsTable: {
            myCommunity: 'Mitt community',
            sentToCommunity: 'Skickad till community',
            noPendingRequests: 'Inga väntande förfrågningar',
            deleteSentRequestTitle: 'Ta bort skickad förfrågan',
            deleteSentRequestDescription: 'Är du säker på att du vill ta bort den skickade förfrågan?',
            removedSentRequestTitle: 'Förfrågan raderad',
            removedSentRequestDescription: 'Den skickade förfrågan raderades framgångsrikt',
          },
          receivedRequestsTable: {
            receivedFromCommunity: 'Mottagen från community',
            myCommunity: 'Mitt community',
            noPendingRequests: 'Inga väntande förfrågningar',
            deleteReceivedRequestTitle: 'Ta bort mottagen förfrågan',
            deleteReceivedRequestDescription: 'Är du säker på att du vill ta bort den mottagna förfrågan?',
            removedReceivedRequestTitle: 'Förfrågan raderad',
            removedReceivedRequestDescription: 'Den mottagna förfrågan raderades framgångsrikt',
          },
          communityConnectRequestPage: {
            title: 'Community länkförfrågan',
            howDoesItWorkTitle: 'Hur fungerar en community-länk?',
            howDoesItWorkDescription: 'Om du accepterar den här inbjudan kommer ditt parkeringscommunity att ansluta sig till dett inbjudande communityt. Detta kommer att tillåta medlemmar i det inbjudande communityt att få tillgång till parkeringsområdena och parkeringsplatserna som är associerade med ditt communitys pris- och tillgänglighetsregler, och medlemmar i ditt community kommer att kunna få tillgång till den inbjudande communityns resurser.',
            acceptRequest: 'Acceptera anslutningsförfrågan',
            acceptedTitle: 'Förfrågan accepterad',
            acceptedDescription: 'Förfrågan accepterades framgångsrikt',
            notFoundTitle: 'Förfrågan hittades inte',
            notFoundDescription: 'Förfrågan hittades inte',
            communityWantsToConnect: '{{communityName}} vill länka samman med ditt community {{communityRecipientName}}.',
            noAccessToAcceptTitle: 'Ingen tillgång',
            noAccessToAcceptDescription: 'Du har inte tillgång att acceptera denna förfrågan.',
          },
          notificationsMenu: {
            title: 'Notiser',
            noNotifications: 'Inga notiser',
          },
          permitQueuePage: {
            title: 'Tillståndskö',
            description: 'På den här sidan hittar du en lista över användare som har begärt ett tillstånd för att parkera på ditt parkeringsområde. Du kan sedan godkänna eller avvisa deras begäran.',
            usersInAreaParkingQueue: 'Användare i parkeringskö',
            usersInSpecificSpotQueue: 'Användare i specifik platskö',
            addUserToQueue: 'Lägg till användare i kö',
            areaParkingQueue: 'Parkeringskö',
            specificSpotsQueue: 'Specifik platskö',
            enableAutomaticQueueForParkingArea: 'Aktivera automatisk kö för parkeringsområdet',
            queueSettings: 'Inställningar för kö',
            allowUsersToJoinParkingQueue: 'Tillåt användare att ställa sig i kö för detta område',
            allowUsersToJoinSpecificSpotsQueue: 'Tillåt användare att ställa sig i kö för specifik parkeringsplats',
            allowUsersToSeeQueueCount: 'Tillåt användare att se hur många som står i kö',
            allowUsersToSeeQueuePosition: 'Tillåt användare att se sin plats i kön',
            enableCommunityMembersOnly: 'Tillåt endast community medlemmar att ställa sig i kö ',
            leaveTheQueue: 'Lämna kön',
            joinParkingAreaQueue: 'Kö till parkeringsområde',
            joinTheQueue: 'Ställ dig i kö',
            joinQueueAndGetNotified: 'Gå med i kön och få besked när en parkeringsplats är ledig.',
            mobileAppPreview: 'Mobilapp förhandsvisning',
            usersInQueueCount: '12 användare i kön',
            userQueuePosition: 'Din plats i kön: 3',
            reorder: 'Ordna om',
            moveToTop: 'Till toppen',
            moveToBottom: 'Till botten',
            moveToSpecificSpot: 'Till specifik plats',
            changeQueuePosition: 'Ändra köposition för {{name}}',
            enterPosition: 'Ange köposition (1 - {{totalItems}})',
            disclaimer: 'Ansvarsfriskrivning',
            disclaimerDescription: 'Om du manuellt ändrar ordning i listan kommer det att återspegla vad som visas för användaren i appen.',
            disclaimerDescriptionAutomaticQueue: 'Välj de parkeringsplatser du vill aktivera för automatiska tillstånd – endast de med ett angivet pris kan väljas. För att sätta ett pris, gå till "Prislista" i menyn till vänster.',
            queueSettingsSavedTitle: 'Inställningar sparade',
            queueSettingsSavedDescription: 'Dina köinställningar har sparats.',
            queuePositionSavedTitle: 'Köpositionen sparades framgångsrikt',
            queuePositionSavedDescription: 'Din position i kön har sparats framgångsrikt.',
            numberOfHoursToAcceptDeclinePermit: 'Antal timmar för att acceptera/avböja tillstånd',
            numberOfHoursToAcceptDeclinePermitDescription: 'Ange hur många timmar användaren har på sig att acceptera eller avböja tillståndserbjudandet innan det går vidare till nästa person i kön.',
            cancellationPeriodInMonths: 'Uppsägningstid (kalendermånader)',
            cancellationPeriodInMonthsDescription: 'Uppsägningstiden gäller alla tillstånd i det här området. När ett tillstånd sägs upp gäller det till sista dagen i det antal kalendermånader som anges, räknat från månaden efter uppsägningen. Standard är 1 månad.',
          },
          permitQueueTable: {
            permit: 'Tillåta',
            inQueueSince: 'I kö sedan',
            noUsersInQueue: 'Inga användare i kö',
            specialRequests: 'Önskemål',
            isRegistered: 'Användarstatus',
            registered: 'Registrerad',
            notRegistered: 'Inte registrerad',
            nobodyInQueue: 'Ingen i kö',
            issuePermit: 'Utfärda tillstånd',
            deletedTitle: 'Borttaget',
            deletedDescription: 'Användaren har tagits bort från tillståndskön.',
            deleteQueueItemTitle: 'Ta bort användare från tillståndskön.',
            deleteQueueItemDescription: 'Detta tar bort användaren från tillståndskön.',
            queueCantBeFetched: 'Kön kan inte hämtas.',
            parkingSpot: 'Parkeringsplats',
            permitType: 'Tillståndstyp',
            offerStatus: 'Status',
            offerExpirationDateTime: 'Erbjudandets utgång',
            offered:  'Erbjuden',
            accepted: 'Accepterad',
            declined: 'Avböjd',
            expired: 'Utgången',
            cancelled: 'Avbruten',
            day: '{{count}} dag',
            day_plural: '{{count}} dagar',
            hour: '{{count}} timme',
            hour_plural: '{{count}} timmar',
            minute: '{{count}} minut',
            minute_plural: '{{count}} minuter',
            expiredAt: 'Utgått kl',
          },
          permitQueueItemModal: {
            titleEdit: 'Redigera en användare i tillståndskön',
            titleAdd: 'Lägg till användare i tillståndskön',
            inputPhone: 'Användarens telefonnummer',
            userInSystem: 'Användare i AirPark-systemet.',
            userNotInSystem: 'Användaren är inte i AirPark-systemet.',
            userNotFoundMessage: 'Användare med telefonnummer `{{phone Number}}` finns inte.',
            parkingSpot: 'Parkeringsplats',
            parkingArea: 'Parkeringsområde',
            permit: 'Tillåta',
            inputSpecialRequests: 'Särskilda önskemål',
            buttonSave: 'Spara',
            permitType: 'Tillståndstyp',
            email: 'E-mail',
            firstName: 'Förnamn',
            lastName: 'Efternamn',
            buttonCancel: 'Avbryt',
            userAlreadyInQueue: 'Användaren är redan i kön.',

          },
          dashboardPage: {
            greeting: 'Hej, {{name}}!',
            createParkingAreaTitle: 'Sätt upp parkeringsområde',
            createParkingAreaDescription: 'För att komma igång med AirPark behöver du först sätta upp ett parkeringsområde. Därefter kan du lägga till prisregler och parkeringstillstånd för området.',
            hereIsYourAirParkOverview: 'Här är en översikt över ditt AirPark.',
            bookingsLastTwentyFourHours: 'Bokningar det senaste dygnet',
            activeParkingPermits: 'Aktiva parkeringstillstånd',
            totalPayouts: 'Totala utbetalningar',
            pendingPayouts: 'Väntande utbetalningar',
            revenue: 'Dina intäkter',
            revenueDescription: 'Dina intäkter senaste 12 månader, efter transaktionsavgifter och AirParks avdrag',
            lastTwelveMonths: 'Senaste 12 månaderna',
            noRevenueYet: 'Inga intäkter ännu',
          },
          statisticsPage: {
            title: 'Statistik',
            description: 'På den här sidan hittar du statistik över dina bokningar och parkeringstillstånd.',
            revenue: 'Intäkter',
            chooseParkingAreas: 'Välj parkeringsområden',
            chooseRevenueType: 'Välj intäktskälla',
            total: 'Totalt',
            bookings: 'Bokningar',
            permits: 'Tillstånd',
            controlfees: 'Kontrollavgifter',
            subletbookings: 'Andrahandsuthyrningar',
            charging: 'Elbilsladdning',
            chooseInterval: 'Välj intervall',
          },
          payoutStatus: {
            pending: 'Pågående',
            processing: 'Under behandling',
            processed: 'Utbetald',
            failed: 'Fel',
            readytoprocess: 'Klar för behandling',
          },
          payoutTransactionType: {
            booking: 'Bokning',
            permit: 'Parkeringstillstånd',
            subletting: 'Andrahandsuthyrning',
          },
          payoutsPage: {
            title: 'Utbetalningar',
            description: 'På den här sidan hittar du en lista över alla utbetalningar som har gjorts till ditt konto.',
            payouts: 'Utbetalningar',
          },
          payoutsTable: {
            payoutDate: 'Utbetalningsdatum',
            noPayoutsFound: 'Inga utbetalningar hittades',
            description: 'Beskrivning',
            period: 'För period'
          },
          payoutDetailsPage: {
            title: 'Utbetalningsdetaljer',
            description: 'På den här sidan hittar du detaljer för din utbetalning med ID {{payoutExtId}}.',
            sum: 'Summa',
            payoutDate: 'Utbetalningsdatum',
            vat: 'Moms',
            status: 'Status',
            payoutLines: 'Utbetalningsrader',
            exportToCsv: 'Exportera till CSV',
            printSummary: 'Skriv ut sammanfattning',
            openCsvTitle: 'Hur öppnar jag en CSV-fil?',
            openCsvDescription: 'För att öppna CSV-filen behöver du ett program som kan läsa CSV-filer som exempelvis Excel eller Numbers. I Numbers behöver du inte göra något speciellt för att öppna filen. I Excel behöver du markera kolumn A, därefter klicka på Data i menyn, välja Text till kolumner, välja Avgränsad, kryssa i Komma och sedan klicka på OK.'
          },
          payoutDetailsTable: {
            type: 'Typ',
            sum: 'Summa',
            amount: 'Belopp',
            vat: 'Moms',
            transactionFee: 'Transaktionsavgift',
            airParkFee: 'AirPark avgift',
            propertyOwnerFee: 'Fastighetsägare avgift',
            subletting: 'Andrahandsuthyrning',
            paymentProvider: 'Betalningsleverantör',
            paymentAmount: 'Betalningsbelopp',
            totalVat: 'Total moms',
            ownerAmount: 'Ägarbelopp',
            subletterAmount: 'Uthyrarens belopp',
            payoutAmount: 'Utbetalningsbelopp',
            vatOnPayoutAmount: 'Moms på utbetalningsbelopp',
            paymentExtId: 'Betalnings-ID',
          },
          controlFeesPage: {
            title: 'Kontrollavgifter',
            description: 'På denna sida kan du hitta en lista över alla dina kontrollavgifter. Du kan också se statusen för varje kontrollavgift.',
            videoInstructionsDescription: 'Titta på vår video för instruktioner om hur man utfärdar kontrollavgifter.',
            signsRequiredTitle: 'Giltiga skyltar krävs',
            signsRequiredDescription: 'Du måste ha giltiga skyltar som uppfyller lagkraven vid entrén till din parkeringsplats som informerar användarna om att de kommer in i en kontrollerad parkeringsplats. Kontakta AirPark om du är osäker eller behöver beställa dessa.',
            contactAirPark: 'Kontakta AirPark',
          },
          controlFeesTable: {
            createdAt: 'Inrapporteringsdatum',
            status: 'Status',
            amount: 'Belopp',
            noControlFeesFound: 'Inga kontrollavgifter hittades',
            pending: 'Under granskning av AirPark',
            approved: 'Godkänd av AirPark',
            rejected: 'Avvisad av AirPark',
            paid: 'Betald',
            overdue: 'Förfallen',
            paymentDue: 'Betalning förfallen',
            unspecified: 'Ej angivet',
            wrongSpot: 'Fel plats',
            overstayed: 'Överskridit tiden',
            forbidden: 'Parkering förbjuden',
            outsideMarks: 'Utanför parkeringsmarkeringar',
            paymentDueDate: 'Betalningsförfallodatum',
            reason: 'Anledning till avgift',
            unpaid: 'Obetald',
            paymentStatus: 'Betalningsstatus',
            notes: 'Anteckningar',
          },
          permitParkingSpotsPage: {
            title: 'Parkeringsplatser med tillstånd',
            description: 'På den här sidan kan du hitta en lista över alla parkeringsplatser som har tillstånd.',
          },
          permitParkingSpotsTable: {
            permits: 'Tillstånd',
            permit: 'tillstånd',
            marketplacePermits: 'tillstånd i marketplace',
            id: 'Id',
            objectId: 'Objekt-id',
            locationSpecific: 'Specifik plats',
            floor: 'Plan',
            number: 'Nummer',
            features: 'Funktioner',
            automatic: 'Automatisk tillstånd',
          },
          permitsModal: {
            id: 'Id',
            spotIdentifier: 'Plats',
            name: 'Namn',
            notes: 'Anteckningar',
            permits: 'Tillstånd'
          },
          controlFeesSettingsPage: {
            title: 'Inställningar för kontrollavgifter',
            description: 'På den här sidan kan du konfigurera inställningar för kontrollavgifter.',
            whoIsAllowedToIssueControlFees: 'Vem får utfärda kontrollavgifter?',
            noone: 'Ingen',
            communityMembers: 'Community-medlemmar',
            everyone: 'Alla',
            controlFeeAmount: 'Kontrollavgiftsbelopp',
            controlFeeSettingsUpdatedTitle: 'Uppdaterat',
            controlFeeSettingsUpdatedDescription: 'Inställningarna för kontrollavgifter har uppdaterats.',
          },
          signsPage: {
            title: 'Skyltmaterial',
            description: 'Ladda hem skyltmaterial för ditt parkeringsområde.',
            alertTitle: 'Övriga skyltar',
            alertDescription: 'Om du behöver officiella vägskyltar för att utfärda kontrollavgifter, kontakta',
          },
          parkingAreaSignsPdf: {
            getTheApp: 'Boka i appen',
            parkingArea: 'Parkeringsområde',
            area: 'Område'
          },
          payoutPrintPage: {
            title: 'Utbetalningsunderlag',
            subletting: 'Andrahandsuthyrning',
            sublettingVat: 'Andrahandsuthyrning, moms',
            bookings: 'Bokningar',
            bookingsVat: 'Bokningar, moms',
            permits: 'Tillstånd',
            permitsVat: 'Tillstånd, moms',
            controlFees: 'Kontrollavgifter',
            controlFeesVat: 'Kontrollavgifter, moms',
            total: 'Totalt inkl. moms',
            totalExVat: 'Totalt exkl. moms',
            totalVat: 'Moms',
            period: 'Period',
            reference: 'Vår referens',
            address: 'Utbetalningsadress',
            vatNumber: 'Momsreg.nr',
            organizationNumber: 'Org.nr',
            payoutReference: 'Utbetalningsreferens',
            payoutDate: 'Utbetalningsdatum',
            charging: 'Elbilsladdning',
            chargingVat: 'Elbilsladdning, moms',
          },
          chargingPage: {
            title: 'Elbilsladdning',
            description: 'På den här sidan kan du konfigurera laddning för dina parkeringsplatser.',
            pricingTitle: 'Pris för elbilsladdning',
            pricingDescription: 'Här kan du konfigurera priser för laddning på dina parkeringsplatser.',
            addChargingStationTitle: 'Lägg till elbilsladdare',
            addChargingStationDescription: 'Här kan du lägga till elbilsladdare på dina parkeringsplatser.',
            priceForCharging: 'Pris',
            priceForChargingTooltip: 'Priset som ska betalas för att ladda elbilen.',
          },
          chargingStationPage: {
            addTitle: 'Lägg till elbilsladdare',
            selectParkingSpot: 'Välj parkeringsplats',
            selectProvider: 'Välj leverantör',
            selectParkingSpotWarning: 'Välj parkeringsplats som elbilsladdaren är tillgänglig på.',
            selectedParkingSpot: '{{spot}} vald',
            addSuccessTitle: 'Elbilsladdare tillagd',
            addSuccessDescription: 'Elbilsladdaren har lagts till.',
            editTitle: 'Redigera elbilsladdare',
            updatedSuccessTitle: 'Elbilsladdare uppdaterad',
            updatedSuccessDescription: 'Elbilsladdaren har uppdaterats.',
          }, 
          waybler: {
            chargingStationId: 'Waybler elbilsladdstations-ID',
            chargingStationIdPlaceholder: 'Ange Waybler elbilsladdstations-ID'
          },
          chargingStationsTable: {
            id: 'Id',
            parkingSpotFloor: 'Parkeringsplats plan',
            parkingSpotNumber: 'Parkeringsplats',
            chargingProvider: 'Leverantör',
            noChargingStationsFound: 'Inga elbilsladdare hittades',
            chargingProviderExternalId: 'Leverantörens elbilsladdstations-ID',
            removeChargingStationTitle: 'Ta bort elbilsladdare',
            removeChargingStationDescription: 'Är du säker på att du vill ta bort elbilsladdaren?',
            removedChargingStationTitle: 'Elbilsladdare borttagen',
            removedChargingStationDescription: 'Elbilsladdaren har tagits bort.',
            noChargingStations: 'Inga elbilsladdare hittades',
            charging: 'Laddar',
            notCharging: 'Laddar inte',
            status: 'Status'
          },
          airPassPage: {
            title: 'AirPass',
            description: 'På den här sidan kan du se dina AirPass för parkeringsområdet. Du kan även markera var dina AirPass är placerade.',
          },
          airPassTable: {
            id: 'Id',
            description: 'Beskrivning',
            location: 'GPS position',
            noAirPassesFound: 'Inga AirPass hittades',
            floor: 'Plan',
            openPassage: 'Öppna passage',
            openPassageConfirmTitle: 'Är du säker?',
            openPassageConfirmDescription: 'Genom att bekräfta skickas en begäran om att öppna passagen "{{description}}" ({{id}}).',
            openPassageSuccessTitle: 'Klart',
            openPassageSuccessDescription: 'Passagen har öppnats.',
            openPassageErrorTitle: 'Fel',
            openPassageErrorDescription: 'Det gick inte att öppna passagen.',
          },
          editAirPassPage: {
            title: 'Redigera AirPass',
            airPassDescriptionTitle: 'Beskrivning',
            airPassDescriptionPlaceholder: 'Ange beskrivning',
            editAirPassPosition: 'Ange AirPass position',
            updatedSuccessTitle: 'Uppdaterad',
            updatedSuccessDescription: 'AirPass har uppdaterats.',
          },
          customAgreementPage: {
            title: 'Anpassat avtal',
            description: 'På den här sidan kan du ladda upp ett anpassat avtal som dina kunder måste godkänna innan de kan acceptera ett parkeringstillstånd.',
            customAgreement: 'Anpassat avtal',
          },
          parkingSpotsPricePage: {
            title: 'Prislista',
            description: 'Visa parkeringsplatser och redigera pris per plats',
            price: 'Pris',
            savedDesc: 'Sparad',
            savedTitle: 'Priset har uppdaterats',
            editPriceTitle: 'Redigera pris för parkeringsplats',
            spotId: 'Parkeringsplats-ID',
            bulkEditPrice: 'Redigera pris i bulk',
},
          bookingsPage: {
            title: 'Bokningar',
            description: 'På den här sidan kan du se en lista över alla bokningar som har gjorts för ditt parkeringsområde.',
            parkingSpot: 'Parkeringsplats',
            startDate: 'Startdatum',
            endDate: 'Slutdatum',
            duration: 'Varaktighet',
            paidAmount: 'Betalt belopp',
            registrationIdentifier: 'Registreringsnummer',
            expired: 'Avslutade',
            noResult: 'Inga bokningar hittades',
          },
          acceptTermsAndConditionsPage: {
            title: 'Godkänn villkor',
            description: 'För att fortsätta kunna använda AirPark behöver du godkänna våra uppdaterade allmänna villkor och integritetspolicy.',
            accept: 'Godkänn',
            privacyPolicy: 'Integritetspolicy',
            termsAndConditions: 'Allmänna villkor',
          }
        },
      }
    }
  });

export default i18n;